import React, { useRef, useState, useEffect } from "react";
import axios from "axios";
import { Link, useNavigate, useParams } from "react-router-dom";
import Slider from "react-slick";
import { Header } from "../Header";
import { Footer } from "../Footer";
import { ReactDialogBox } from "react-js-dialog-box";
import generatePDF from "./PDFscore";
import "react-js-dialog-box/dist/index.css";
import "../assets/ohs/admin.css";
import "../assets/ohs/responsibility.css";
import "../assets/ohs/worker.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
export const WorkerinductionEmergency = () => {
  const inputRef = useRef(null);
  const inputRef_q1 = useRef(null);
  const inputRef_q2 = useRef(null);
  const snd = useRef();
  const third = useRef();
  const forth = useRef();
  const fifth = useRef();
  const sixth = useRef();
  const stepSecond = useRef();
  const stepforth = useRef();
  const stepthird = useRef();
  const { id } = useParams();
  const [PdfcardImg, setPdfcardImg] = useState("");
  const [scoreCard, setscoreCard] = useState("");
  const changeFavicon = (url) => {
    const favicon = document.querySelector('link[rel="icon"]');
    if (favicon) {
      favicon.href = url;
    }
  };
  const [name_9, setname_9] = useState(false);
  const [closeBox, setcloseBox] = useState(true);
  const [worngansQuiz_1_1, setworngansQuiz_1_1] = useState(false);
  const [rightansQuiz_1_1, setrightansQuiz_1_1] = useState(false);
  const [lesson1, setlesson1] = useState(true);
  const [lesson2, setlesson2] = useState(false);
  const [lesson3, setlesson3] = useState(false);
  const [lesson4, setlesson4] = useState(false);
  const [lesson5, setlesson5] = useState(false);
  const [lesson6, setlesson6] = useState(false);
  const [leftmenu_bar, setleftmenu_bar] = useState(0);
  const [barwidth, setbarwidth] = useState(0);
  //Lesson 1 Start
  const [strokeDashArray_less1, setStrokeDashArray_less1] = useState("");
  const [istruefalse_1, setistruefalse_1] = useState(false);

  //Lesson 1 End

  //Lesson 2 Start
  const [strokeDashArray_less2, setStrokeDashArray_less2] = useState("");
  const [istruefalse_2, setistruefalse_2] = useState(false);
  //Lesson 2 End

  //Lesson 3 Start
  const [strokeDashArray_less3, setStrokeDashArray_less3] = useState("");
  const [istruefalse_3, setistruefalse_3] = useState(false);
  const [less_3_ans, setless_3_ans] = useState(false);
  const [less_3_subbtn, setless_3_subbtn] = useState(false);
  const [less_3_contBtn, setless_3_contBtn] = useState(false);
  const [woodvalue, setwoodvalue] = useState([]);
  const [corr_ans, setcorr_ans] = useState(false);
  //Lesson 3 end

  //Lesson 4 Start
  const [strokeDashArray_less4, setStrokeDashArray_less4] = useState("");
  const [istruefalse_4, setistruefalse_4] = useState(false);
  const [tabsectionView_4, settabsectionView_4] = useState(false);
  const [istabreview, setistabreview] = useState([]);
  const [tabsectionView, settabsectionView] = useState("Tab1");
  const [btn_3, setbtn_3] = useState(false);
  //Lesson 4 end

  //Lesson 5 start
  const [strokeDashArray_less5, setStrokeDashArray_less5] = useState("");
  const [istruefalse_5, setistruefalse_5] = useState(false);
  const [clickCount, setClickCount] = useState(0);
  const [clickCount_1, setClickCount_1] = useState(0);
  const [clickCount_2, setClickCount_2] = useState(0);
  var settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    afterChange: (slide) => setCurrentSlide(slide),
  };
  var settings_2 = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    afterChange: (slide) => setCurrentSlide_2(slide),
  };
  var settings_3 = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    afterChange: (slide) => setCurrentSlide_3(slide),
  };

  //Lesson 5 End
  //Lesson 6 Start
  const [sec_1, setsec_1] = useState(true);
  const [name_6, setname_6] = useState(false);
  const [quizless_6_1, setquizless_6_1] = useState(false);
  const [quizless_6_2, setquizless_6_2] = useState(false);
  const [quizless_6_3, setquizless_6_3] = useState(false);
  const [quizless_6_4, setquizless_6_4] = useState(false);
  const [quizless_6_5, setquizless_6_5] = useState(false);
  const [less_5_finresult, setless_5_finresult] = useState(false);
  const [checkQ_6_1, setcheckQ_6_1] = useState("");
  const [isfirstquiz_6_1, setisfirstquiz_6_1] = useState(false);
  const [issetQuizAns_6_1_btn, setissetQuizAns_6_1_btn] = useState(false);
  const [isOpacity_6, setisOpacity_6] = useState(false);

  const [worngansQuiz_6_1, setworngansQuiz_6_1] = useState(false);
  const [rightansQuiz_6_1, setrightansQuiz_6_1] = useState(false);
  const [q1_6_next, setq1_6_next] = useState(false);
  const [checkbtn_quiz_1_6, setcheckbtn_quiz_1_6] = useState(false);

  const [isOpacity_6_1, setisOpacity_6_1] = useState(false);
  const [checkQ_6_2, setcheckQ_6_2] = useState(false);
  const [isfirstquiz_6_2, setisfirstquiz_6_2] = useState(false);
  const [issetQuizAns_6_2_btn, setissetQuizAns_6_2_btn] = useState(false);

  const [checkbtn_quiz_2_6, setcheckbtn_quiz_2_6] = useState(false);
  const [q2_6_next, setq2_6_next] = useState(false);

  const [checkQ_6_3, setcheckQ_6_3] = useState(false);
  const [isfirstquiz_6_3, setisfirstquiz_6_3] = useState(false);
  const [issetQuizAns_6_3_btn, setissetQuizAns_6_3_btn] = useState(false);

  const [checkbtn_quiz_3_6, setcheckbtn_quiz_3_6] = useState(false);
  const [q3_6_next, setq3_6_next] = useState(false);

  const [checkQ_6_4, setcheckQ_6_4] = useState(false);
  const [isfirstquiz_6_4, setisfirstquiz_6_4] = useState(false);
  const [issetQuizAns_6_4_btn, setissetQuizAns_6_4_btn] = useState(false);

  const [checkbtn_quiz_4_6, setcheckbtn_quiz_4_6] = useState(false);
  const [q4_6_next, setq4_6_next] = useState(false);

  const [checkQ_6_5, setcheckQ_6_5] = useState(false);
  const [isfirstquiz_6_5, setisfirstquiz_6_5] = useState(false);
  const [issetQuizAns_6_5_btn, setissetQuizAns_6_5_btn] = useState(false);

  const [checkbtn_quiz_5_6, setcheckbtn_quiz_5_6] = useState(false);
  const [q5_6_next, setq5_6_next] = useState(false);
  const [score__per5, setscore__per5] = useState([]);
  const [score_5, setscore_5] = useState([]);
  const [corrScore, setcorrScore] = useState(false);
  const [strokeDashArray_less6, setStrokeDashArray_less6] = useState("");
  const [istruefalse_6, setistruefalse_6] = useState(false);
  //Lesson 6 End

  useEffect(() => {
    const userStr = JSON.parse(localStorage.getItem("users"));

    if (userStr === null) {
      window.location.href = "/login";
    }
    changeFavicon(require("../assets/admin/images/f-icon.png"));

    document.title = "Start Course";

    let formdata = {
      code: id,
    };
    console.log(woodvalue.length);
    if (woodvalue.length === 4) {
      setless_3_subbtn(true);
    } else {
      setless_3_subbtn(false);
      setcorr_ans(false);
      setless_3_ans(false);
    }

    if (istabreview.length === 4) {
      settabsectionView_4(true);
      setStrokeDashArray_less4(200.36);
    }
    var totalc = clickCount + clickCount_1 + clickCount_2;
    console.log(totalc);
    if (totalc === 12) {
      setbtn_3(true);
    }
    if (scoreCard != "") {
      pdfdataget();
      setscoreCard("");
    }
  }, [
    id,
    woodvalue,
    istabreview,
    clickCount,
    clickCount_1,
    clickCount_2,
    scoreCard,
    PdfcardImg,
  ]);
  function formatDate_notes() {
    const options = {
      day: "2-digit",
      month: "long", // Change to "long" for full month name
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      timeZone: "Australia/Perth",
    };

    const date = new Date();
    return date.toLocaleDateString("en-GB", options);
  }
  //Pdf
  function getimagedata(urll) {
    let formdata = {
      url: urll,
    };
    const imgBase64 =
      "data:image/png;base64,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";
    const mainpdf = (
      <html lang="en">
        <head>
          <meta charset="utf-8" />
          <link rel="icon" href="/" />
          <meta name="viewport" content="width=device-width, initial-scale=1" />
          <meta name="theme-color" content="#000000" />
          <meta
            name="description"
            content="Web site created using create-react-app"
          />
          <link
            href="https://fonts.googleapis.com/css2?family=Great+Vibes&family=Quattrocento:wght@400;700&display=swap"
            rel="stylesheet"
          />
        </head>
        <body>
          <table
            style={{
              width: "700px",
              margin: "0 auto",
              border: "10px solid rgb(0, 74, 173)",
            }}
          >
            <tbody style={{ width: "100%" }}>
              <tr>
                <td style={{ textAlign: "center" }}>
                  <div
                    style={{
                      margin: "0 auto",
                      width: "250px",
                    }}
                  >
                    <img style={{ width: "50%" }} src={imgBase64} alt="logo" />
                  </div>
                </td>
              </tr>
              <tr>
                <td>
                  <h1
                    style={{
                      color: "rgb(0, 74, 173)",
                      fontSize: "35px",
                      textAlign: "center",
                      padding: "0px 0px",
                      fontFamily: '"Quattrocento", serif',
                    }}
                  >
                    Certificate of Training
                  </h1>
                </td>
              </tr>
              <tr>
                <td>
                  <h2
                    style={{
                      color: "#323232",
                      fontWeight: 400,
                      fontSize: "20px",
                      textAlign: "center",
                      padding: "5px 0px",
                      fontFamily: '"Quattrocento", serif',
                    }}
                  >
                    This is to certify that
                  </h2>
                </td>
              </tr>
              <tr>
                <td>
                  <div>
                    <h3
                      style={{
                        color: "#323232",
                        fontWeight: 400,
                        marginTop: "30px",
                        fontSize: "20px",
                        textAlign: "center",
                        padding: "5px 0px",
                        fontFamily: '"Quattrocento", serif',
                      }}
                    >
                      {name_9}
                    </h3>
                  </div>
                </td>
              </tr>
              <tr>
                <td>
                  <h2
                    style={{
                      color: "#323232",
                      fontWeight: 400,
                      marginTop: "30px",
                      fontSize: "20px",
                      textAlign: "center",
                      padding: "5px 0px",
                      fontFamily: '"Quattrocento", serif',
                    }}
                  >
                    has successfully completed training in
                  </h2>
                </td>
              </tr>
              <tr>
                <td>
                  <div>
                    <h3
                      style={{
                        color: "#000",
                        fontWeight: 400,
                        fontSize: "20px",
                        textAlign: "center",
                        margin: "12px 0px",
                        fontFamily: '"Quattrocento", serif',
                      }}
                    >
                      Worker induction - emergency preparedness
                    </h3>
                  </div>
                </td>
              </tr>
              <tr>
                <td>
                  <div
                    style={{
                      padding: "10px 0px",
                      marginTop: "15px",
                    }}
                  >
                    <h5
                      style={{
                        color: "#000",
                        fontWeight: 400,
                        fontSize: "20px",
                        textAlign: "center",
                        margin: "0px 0px",
                        fontFamily: '"Quattrocento", serif',
                      }}
                    >
                      undertaken on the date
                    </h5>
                    <h6
                      style={{
                        color: "#000",
                        fontWeight: 400,
                        fontSize: "20px",
                        textAlign: "center",
                        margin: "0px 0px",
                        fontFamily: '"Quattrocento", serif',
                      }}
                    >
                      {formatDate_notes()}
                    </h6>
                  </div>
                </td>
              </tr>
              <tr>
                <td>
                  <h2
                    style={{
                      color: "#323232",
                      fontWeight: 400,
                      fontSize: "20px",
                      textAlign: "center",
                      paddingTop: "40px",
                      fontFamily: '"Quattrocento", serif',
                    }}
                  >
                    Delivered by:
                  </h2>
                </td>
              </tr>
              <tr>
                <td style={{ textAlign: "center" }}>
                  <div
                    style={{
                      margin: "0 auto",
                      width: "250px",
                      paddingBottom: "10px",
                    }}
                  >
                    <img style={{ width: "50%" }} src={imgBase64} alt="logo" />
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </body>
      </html>
    );
    const filenamee = "Worker induction - emergency preparedness";

    setTimeout(() => {
      generatePDF(mainpdf, filenamee);
    }, 500);
  }
  const pdfdataget = async () => {
    const cc = await getimagedata("logo1.png");
  };
  const downloadpdf = () => {
    const userStr = JSON.parse(localStorage.getItem("users"));

    let formdata = {
      user_id: userStr[0].id,
      id: id,
      name: name_9,
    };
    console.log(formdata);
    //setscoreCard(1);

    axios
      .post("https://jlmining.app/coursepdf", formdata, {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      })
      .then((res) => { })
      .catch((err) => { });
    pdfdataget();
  };
  //Pdf
  //Lesson Start 1
  const nextsection = (event) => {
    if (event === "1") {
      setlesson1(false);
      setlesson2(true);
      setistruefalse_1(true);
      setStrokeDashArray_less1(458.36);
      setleftmenu_bar(16.66);
      setbarwidth(20);
      setTimeout(() => {
        snd.current.scrollIntoView({ behavior: "smooth" });
      }, 100);
    }
    if (event === "2") {
      setlesson2(false);
      setlesson3(true);
      setistruefalse_2(true);
      setStrokeDashArray_less2(458.36);
      setleftmenu_bar(33.32);
      setbarwidth(30);
      setTimeout(() => {
        stepSecond.current.scrollIntoView({ behavior: "smooth" });
      }, 100);
    }
    if (event === "3") {
      setlesson3(false);
      setlesson4(true);
      setistruefalse_3(true);
      setStrokeDashArray_less3(458.36);
      setleftmenu_bar(49.98);
      setbarwidth(50);
      setTimeout(() => {
        stepthird.current.scrollIntoView({ behavior: "smooth" });
      }, 100);
    }
    if (event === "4") {
      setlesson4(false);
      setlesson5(true);
      setistruefalse_4(true);
      setStrokeDashArray_less4(458.36);
      setleftmenu_bar(66.64);
      setbarwidth(60);
      setTimeout(() => {
        stepforth.current.scrollIntoView({ behavior: "smooth" });
      }, 100);
    }
    if (event === "5") {
      setlesson5(false);
      setlesson6(true);
      setistruefalse_5(true);
      setStrokeDashArray_less5(458.36);
      setleftmenu_bar(83.3);
      setbarwidth(80);
    }
  };
  //Lesson End 1

  //Lesson Start 3
  const startfire_3 = (event) => {
    const value = event.target.value; // Extracting the value from the event

    if (event.target.checked) {
      // If the checkbox is checked, add the value to the array
      setwoodvalue((prevState) => [...prevState, value]);
    } else {
      // If the checkbox is unchecked, remove the value from the array
      setwoodvalue((prevState) => prevState.filter((item) => item !== value));
    }
  };
  const checkSection = () => {
    const sequence = ["1", "2", "3", "4"];

    // Check if the values match the sequence
    const isSequenceMatched = sequence.every(
      (value, index) => woodvalue[index] === value
    );
    setless_3_ans(true);
    console.log(woodvalue);
    console.log(sequence);
    if (isSequenceMatched === true) {
      setcorr_ans(true);
    }
  };
  const refreshsection_3 = () => {
    setwoodvalue([]);
    setcorr_ans(false);
    setless_3_ans(false);
    setless_3_subbtn(false);
  };
  //Lesson End 3

  //Lesson Start 4
  const tabReview_4 = (event) => {
    if (!istabreview.includes(event)) {
      setistabreview((prevState) => [...prevState, event]);
    }
    settabsectionView(event);
  };
  //Lesson End 4
  const lessonInstruction = (event) => {
    if (event === "1") {
      setlesson1(true);
      setlesson2(false);
      setistruefalse_1(false);
      setStrokeDashArray_less1("");
    }
    if (event === "2") {
      setlesson2(true);
      setlesson3(false);
      setistruefalse_2(false);
      setStrokeDashArray_less2("");
    }
    if (event === "3") {
      setlesson3(true);
      setlesson4(false);
      setistruefalse_3(false);
      setStrokeDashArray_less3("");
      refreshsection_3();
    }
    if (event === "4") {
      setlesson4(true);
      setlesson5(false);
      setistruefalse_4(false);
      setStrokeDashArray_less4("");
    }
    if (event === "5") {
      setlesson5(true);
      setlesson6(false);
      setistruefalse_5(false);
      setStrokeDashArray_less5("");
    }
  };

  const setCurrentSlide = () => {
    if (clickCount < 4) {
      setClickCount((prevCount) => prevCount + 1);
    }
    // if (clickCount === 1) {
    //   setstrokeDashArray_less7(300.36);
    // }
    // if (clickCount === 2) {
    //   setstrokeDashArray_less7(365.36);
    // }
    // if (clickCount === 3) {
    //   setstrokeDashArray_less7(400.36);
    // }
    // if (clickCount >= 4) {
    //   setbtn7(true);
    //   setstrokeDashArray_less7(458.36);
    // }
  };
  const setCurrentSlide_2 = () => {
    if (clickCount_1 < 4) {
      setClickCount_1((prevCount_1) => prevCount_1 + 1);
    }
  };
  const setCurrentSlide_3 = () => {
    if (clickCount_2 < 4) {
      setClickCount_2((prevCount) => prevCount + 1);
    }
  };

  //lesson 6
  const entername_6 = (event) => {
    const trimmedValue = event.target.value.trim();
    setname_6(trimmedValue);
  };
  const btn_entername = () => {
    if (name_6 !== false) {
      setquizless_6_1(true);
      setsec_1(false);
    }
  };
  const startQuiz_6_1 = (event) => {
    setcheckQ_6_1(event);
    setcheckbtn_quiz_1_6(true);
  };
  const startQuiz_6_2 = (event) => {
    setcheckQ_6_2(event);
    setcheckbtn_quiz_2_6(true);
  };
  const startQuiz_6_3 = (event) => {
    setcheckQ_6_3(event);
    setcheckbtn_quiz_3_6(true);
    setworngansQuiz_6_1(false);
    setrightansQuiz_6_1(false);
  };
  const startQuiz_6_4 = (event) => {
    setcheckQ_6_4(event);
    setcheckbtn_quiz_4_6(true);
    setworngansQuiz_6_1(false);
    setrightansQuiz_6_1(false);
  };
  const startQuiz_6_5 = (event) => {
    setcheckQ_6_5(event);
    setcheckbtn_quiz_5_6(true);
    setworngansQuiz_6_1(false);
    setrightansQuiz_6_1(false);
  };
  const Quiz_check_6 = (event) => {
    if (event === "1") {
      setisOpacity_6(true);
      if (checkQ_6_1 === "Fuel") {
        setscore_5((prevArray) => [...prevArray, 8]);
        setscore__per5((prevArray) => [...prevArray, 20]);
        setrightansQuiz_6_1(true);
        setworngansQuiz_6_1(false);
      } else {
        setworngansQuiz_6_1(true);
        setrightansQuiz_6_1(false);
      }
      setissetQuizAns_6_1_btn("Fuel");
      setisfirstquiz_6_1(true);
      setq1_6_next(true);
      setcheckbtn_quiz_1_6(false);
      setcheckQ_6_1("");
      setStrokeDashArray_less6(200.36);
    }
    if (event === "2") {
      setisOpacity_6(true);
      if (checkQ_6_2 === "Class_H") {
        setscore_5((prevArray) => [...prevArray, 8]);
        setscore__per5((prevArray) => [...prevArray, 20]);
        setrightansQuiz_6_1(true);
        setworngansQuiz_6_1(false);
      } else {
        setworngansQuiz_6_1(true);
        setrightansQuiz_6_1(false);
      }
      setissetQuizAns_6_2_btn("Class_H");
      setisfirstquiz_6_2(true);
      setq2_6_next(true);
      setcheckbtn_quiz_2_6(false);
      setcheckQ_6_2("");
      setStrokeDashArray_less6(300.36);
    }
    if (event === "3") {
      setisOpacity_6(true);
      if (checkQ_6_3 === "Fire_Warden") {
        setscore_5((prevArray) => [...prevArray, 8]);
        setscore__per5((prevArray) => [...prevArray, 20]);
        setrightansQuiz_6_1(true);
        setworngansQuiz_6_1(false);
      } else {
        setworngansQuiz_6_1(true);
        setrightansQuiz_6_1(false);
      }
      setissetQuizAns_6_3_btn("Fire_Warden");
      setisfirstquiz_6_3(true);
      setq3_6_next(true);
      setcheckbtn_quiz_3_6(false);
      setcheckQ_6_3("");
      setStrokeDashArray_less6(350.36);
    }
    if (event === "4") {
      setisOpacity_6(true);
      if (checkQ_6_4 === "Tell_a") {
        setscore_5((prevArray) => [...prevArray, 8]);
        setscore__per5((prevArray) => [...prevArray, 20]);
        setrightansQuiz_6_1(true);
        setworngansQuiz_6_1(false);
      } else {
        setworngansQuiz_6_1(true);
        setrightansQuiz_6_1(false);
      }
      setissetQuizAns_6_4_btn("Tell_a");
      setisfirstquiz_6_4(true);
      setq4_6_next(true);
      setcheckbtn_quiz_4_6(false);
      setcheckQ_6_4("");
      setStrokeDashArray_less6(400.36);
    }
    if (event === "5") {
      setisOpacity_6(true);
      if (checkQ_6_5 === "Bush_fires") {
        setscore_5((prevArray) => [...prevArray, 8]);
        setscore__per5((prevArray) => [...prevArray, 20]);
        setrightansQuiz_6_1(true);
        setworngansQuiz_6_1(false);
      } else {
        setworngansQuiz_6_1(true);
        setrightansQuiz_6_1(false);
      }
      setissetQuizAns_6_5_btn("Bush_fires");
      setisfirstquiz_6_5(true);
      setq5_6_next(true);
      setcheckbtn_quiz_5_6(false);
      setcheckQ_6_5("");

      setistruefalse_6(true);
      setStrokeDashArray_less6(458.36);
    }
  };
  const Quiz_next_6 = (event) => {
    setworngansQuiz_6_1(false);
    setrightansQuiz_6_1(false);
    if (event === "1") {
      setquizless_6_2(true);
      setquizless_6_1(false);
      setcheckbtn_quiz_1_6(false);
    }
    if (event === "2") {
      setquizless_6_3(true);
      setquizless_6_2(false);
      setrightansQuiz_6_1(false);
      setcheckbtn_quiz_2_6(false);
    }
    if (event === "3") {
      setquizless_6_4(true);
      setquizless_6_3(false);
      setcheckbtn_quiz_3_6(false);
    }
    if (event === "4") {
      setquizless_6_5(true);
      setquizless_6_4(false);
      setcheckbtn_quiz_4_6(false);
    }
    if (event === "5") {
      setquizless_6_5(false);
      setless_5_finresult(true);
      setleftmenu_bar(100);
      setbarwidth(100);
      const sum = score_5.reduce(
        (accumulator, currentValue) => accumulator + currentValue,
        0
      );
      const sum_per = score__per5.reduce(
        (accumulator, currentValue) => accumulator + currentValue,
        0
      );
      setscore_5(sum);
      setscore__per5(sum_per);
      if (sum_per >= 80) {
        setcorrScore(true);
      }
    }
  };
  //lesson 6
  const menubars = () => {
    setcloseBox(!closeBox);
  };
  const refreshbtn = (event) => {
    console.log("ss");
    setless_5_finresult(false);
    setsec_1(true);
    setname_6(false);
    setquizless_6_1(false);
    setquizless_6_2(false);
    setquizless_6_3(false);
    setquizless_6_4(false);
    setquizless_6_5(false);

    setcheckQ_6_1("");
    setisfirstquiz_6_1(false);
    setissetQuizAns_6_1_btn(false);
    setisOpacity_6(false);
    setworngansQuiz_6_1(false);
    setrightansQuiz_6_1(false);
    setq1_6_next(false);
    setcheckbtn_quiz_1_6(false);
    setisOpacity_6_1(false);
    setcheckQ_6_2(false);
    setisfirstquiz_6_2(false);
    setissetQuizAns_6_2_btn(false);
    setcheckbtn_quiz_2_6(false);
    setq2_6_next(false);
    setcheckQ_6_3(false);
    setisfirstquiz_6_3(false);
    setissetQuizAns_6_3_btn(false);
    setcheckbtn_quiz_3_6(false);
    setq3_6_next(false);
    setcheckQ_6_4(false);
    setisfirstquiz_6_4(false);
    setissetQuizAns_6_4_btn(false);
    setcheckbtn_quiz_4_6(false);
    setq4_6_next(false);
    setcheckQ_6_5(false);
    setisfirstquiz_6_5(false);
    setissetQuizAns_6_5_btn(false);
    setcheckbtn_quiz_5_6(false);
    setq5_6_next(false);
    setscore__per5([]);
    setscore_5([]);
    setcorrScore(false);
    setStrokeDashArray_less6("");
    setistruefalse_6(false);
  };
  return (
    <>
      <div
        className={`d-flex main-admin-block align-items-stretch mt-4 ${closeBox ? "" : "close-box"
          }`}
      >
        <div className="flex-shrink-0 side-layer mt-4">
          <div className="scroll-height">
            <div className="d-flex flex-column">
              <div className="top-title d-flex flex-column gap-5">
                <h1>
                  Worker Health And Safety Induction Training- Emergency
                  Preparedness
                </h1>
                <div className="d-flex flex-column gap-1">
                  <div className="progress-bar-full">
                    <div style={{ width: `${barwidth}%` }}></div>
                  </div>
                  <h4 className="pro-number">
                    <span>{leftmenu_bar}%</span> COMPLETE
                  </h4>
                </div>
              </div>

              <div className="d-flex flex-column side-navbar mt-4">
                <Link
                  to="admin-block.html"
                  className="d-flex align-items-center gap-3 list-link anilink active"
                >
                  <div className="flex-shrink-0">
                    <i className="far fa-align-left"></i>
                  </div>
                  <div className="flex-grow-1">
                    <h4>Introduction And Legislation</h4>
                  </div>
                  <div className="flex-shrink-0">
                    <div className="circle-small">
                      {istruefalse_1 && <i className="fas fa-check-circle"></i>}
                      {!istruefalse_1 && (
                        <svg>
                          <circle
                            className="bg"
                            cx="40"
                            cy="40"
                            r="37"
                          ></circle>
                          <circle
                            style={{ strokeDasharray: strokeDashArray_less1 }}
                            className="progress two"
                            cx="40"
                            cy="40"
                            r="37"
                          ></circle>
                        </svg>
                      )}
                    </div>
                  </div>
                </Link>
                <Link
                  to="#!"
                  className="d-flex align-items-center gap-3 list-link disable-box rel"
                  data-bs-toggle="tooltip"
                  data-bs-title="Lessons must be completed in order"
                >
                  <div className="flex-shrink-0">
                    <i className="far fa-align-left"></i>
                  </div>
                  <div className="flex-grow-1">
                    <h4>Worker Responsibilities</h4>
                  </div>
                  <div className="flex-shrink-0">
                    <div className="circle-small">
                      {istruefalse_2 && <i className="fas fa-check-circle"></i>}
                      {!istruefalse_2 && (
                        <svg>
                          <circle
                            className="bg"
                            cx="40"
                            cy="40"
                            r="37"
                          ></circle>
                          <circle
                            style={{ strokeDasharray: strokeDashArray_less2 }}
                            className="progress two"
                            cx="40"
                            cy="40"
                            r="37"
                          ></circle>
                        </svg>
                      )}
                    </div>
                  </div>
                </Link>
                <Link
                  to="#!"
                  className="d-flex align-items-center gap-3 list-link disable-box rel"
                  data-bs-toggle="tooltip"
                  data-bs-title="Lessons must be completed in order"
                >
                  <div className="flex-shrink-0">
                    <i className="far fa-align-left"></i>
                  </div>
                  <div className="flex-grow-1">
                    <h4>Emergency Planning and Procedures Awareness</h4>
                  </div>
                  <div className="flex-shrink-0">
                    <div className="circle-small">
                      {istruefalse_3 && <i className="fas fa-check-circle"></i>}
                      {!istruefalse_3 && (
                        <svg>
                          <circle
                            className="bg"
                            cx="40"
                            cy="40"
                            r="37"
                          ></circle>
                          <circle
                            style={{ strokeDasharray: strokeDashArray_less3 }}
                            className="progress two"
                            cx="40"
                            cy="40"
                            r="37"
                          ></circle>
                        </svg>
                      )}
                    </div>
                  </div>
                </Link>
                <Link
                  to="#!"
                  className="d-flex align-items-center gap-3 list-link disable-box rel"
                  data-bs-toggle="tooltip"
                  data-bs-title="Lessons must be completed in order"
                >
                  <div className="flex-shrink-0">
                    <i className="far fa-align-left"></i>
                  </div>
                  <div className="flex-grow-1">
                    <h4>The Fire Tetrahedron And Extinguisher Types</h4>
                  </div>
                  <div className="flex-shrink-0">
                    <div className="circle-small">
                      {istruefalse_4 && <i className="fas fa-check-circle"></i>}
                      {!istruefalse_4 && (
                        <svg>
                          <circle
                            className="bg"
                            cx="40"
                            cy="40"
                            r="37"
                          ></circle>
                          <circle
                            style={{ strokeDasharray: strokeDashArray_less4 }}
                            className="progress two"
                            cx="40"
                            cy="40"
                            r="37"
                          ></circle>
                        </svg>
                      )}
                    </div>
                  </div>
                </Link>
                <Link
                  to="#!"
                  className="d-flex align-items-center gap-3 list-link disable-box rel"
                  data-bs-toggle="tooltip"
                  data-bs-title="Lessons must be completed in order"
                >
                  <div className="flex-shrink-0">
                    <i className="far fa-align-left"></i>
                  </div>
                  <div className="flex-grow-1">
                    <h4>How to response to an emergency</h4>
                  </div>
                  <div className="flex-shrink-0">
                    <div className="circle-small">
                      {istruefalse_5 && <i className="fas fa-check-circle"></i>}
                      {!istruefalse_5 && (
                        <svg>
                          <circle
                            className="bg"
                            cx="40"
                            cy="40"
                            r="37"
                          ></circle>
                          <circle
                            style={{ strokeDasharray: strokeDashArray_less5 }}
                            className="progress two"
                            cx="40"
                            cy="40"
                            r="37"
                          ></circle>
                        </svg>
                      )}
                    </div>
                  </div>
                </Link>
                <Link
                  to="#!"
                  className="d-flex align-items-center gap-3 list-link disable-box rel"
                  data-bs-toggle="tooltip"
                  data-bs-title="Lessons must be completed in order"
                >
                  <div className="flex-shrink-0">
                    <i className="far fa-align-left"></i>
                  </div>
                  <div className="flex-grow-1">
                    <h4>Final Assessment</h4>
                  </div>
                  <div className="flex-shrink-0">
                    <div className="circle-small">
                      {istruefalse_6 && <i className="fas fa-check-circle"></i>}
                      {!istruefalse_6 && (
                        <svg>
                          <circle
                            className="bg"
                            cx="40"
                            cy="40"
                            r="37"
                          ></circle>
                          <circle
                            style={{ strokeDasharray: strokeDashArray_less6 }}
                            className="progress two"
                            cx="40"
                            cy="40"
                            r="37"
                          ></circle>
                        </svg>
                      )}
                    </div>
                  </div>
                </Link>
              </div>
            </div>
          </div>
        </div>
        <div className="flex-grow-1 rightpart">
          {lesson1 && (
            <section id="introd" className="intro w-100">
              <div className="d-flex flex-column">
                <Link
                  to={`/start-course/${id}`}
                  className="backpage text-center d-flex flex-column"
                >
                  <i className="far fa-angle-up"></i>
                  <h5>home</h5>
                </Link>
                <div className="stop">
                  <button
                    type="button"
                    className="tbtn"
                    onClick={() => menubars()}
                  >
                    <i className="fal fa-bars" aria-hidden="true"></i>
                  </button>
                </div>
              </div>
              <div className="container-xxl px-0">
                <div className="row">
                  <div className="col-lg-10 offset-md-1">
                    <div className="d-flex flex-column gap-3 padding py-5 lesson-block intro">
                      <h4>Lesson 1 of 6</h4>
                      <h1>Introduction And Legislation</h1>
                      <div className="line"></div>
                    </div>
                  </div>
                  <div className="col-12">
                    <div className="border-line">
                      <div className="line-per"></div>
                    </div>
                  </div>
                  <div className="col-lg-10 offset-md-1">
                    <div className="d-flex flex-column gap-3 py-3 pt-md-5">
                      <p className="padding">
                        The organization is dedicated to implementing and
                        upholding protocols aimed at managing emergency
                        situations that may pose risks to workers.
                      </p>
                    </div>
                    <div
                      id="legal"
                      className="d-flex flex-column padding py-3 py-md-5 introdu"
                    >
                      <h5>Legal Obligations</h5>
                      <p>
                        Legal obligations mandate that organizations prepare an
                        emergency plan for their workplace, as stipulated by
                        health and safety legislation. This plan serves as a
                        documented guide detailing actions to be taken by
                        workers and others during emergencies. Crucially, the
                        plan must be tailored to the specific characteristics of
                        the workplace it addresses.
                      </p>
                      <p>The emergency plan should include:</p>
                      <ul className="py-5 d-flex flex-column gap-3">
                        <li>
                          <p>
                            Detailed emergency procedures designed to
                            effectively respond to workplace-specific
                            emergencies, considering potential scenarios.
                          </p>
                        </li>
                        <li>
                          <p>
                            Contact information for emergency services,
                            including specialized services like HAZMAT teams.
                          </p>
                        </li>
                        <li>
                          <p>
                            Identification of nearby medical facilities and
                            provisions for first aid.
                          </p>
                        </li>
                        <li>
                          <p>
                            Establishment of command and control structures to
                            ensure efficient communication with all individuals
                            at the workplace and timely notification of
                            emergency service organizations.
                          </p>
                        </li>
                        <li>
                          <p>
                            Scheduled testing of emergency procedures to ensure
                            their effectiveness.
                          </p>
                        </li>
                        <li>
                          <p>
                            Provision of information, training, and instruction
                            to relevant individuals regarding emergency
                            procedures implementation, including temporary
                            staff, contract workers, and visitors.
                          </p>
                        </li>
                        <li>
                          <p>
                            Adherence to any additional requirements outlined in
                            regulations, such as specific plans for major hazard
                            facilities.
                          </p>
                        </li>
                      </ul>

                      <p>
                        The organization is responsible for maintaining and
                        updating the emergency plan as needed to ensure its
                        continued effectiveness and relevance. Changes in
                        workplace conditions, such as relocations, renovations,
                        staff composition changes, or the introduction of new
                        activities, may necessitate updates to the plan. Regular
                        evacuation training should be provided to relevant
                        individuals during induction and periodically
                        thereafter, typically annually for most workplaces, to
                        support effective plan maintenance.
                      </p>
                      <p className="py-5">
                        A comprehensive emergency plan typically encompasses
                        preparations for fires, medical emergencies, workplace
                        incidents, and, if relevant, rescue operations.
                        Nevertheless, it is imperative that the plan also
                        accounts for any specific hazards associated with the
                        workplace and its geographical location.
                      </p>
                      <p>
                        Depending on the nature and location of the
                        organization, this may involve protocols for:
                      </p>
                      <ul className="py-5 d-flex flex-column gap-3">
                        <li>
                          <p>Handling hazardous chemical incidents.</p>
                        </li>
                        <li>
                          <p>Addressing threatening situations.</p>
                        </li>
                        <li>
                          <p>
                            Managing catastrophic plant or equipment failures.
                          </p>
                        </li>
                        <li>
                          <p>
                            Responding to adverse weather conditions such as
                            cyclones, snowstorms, and thunderstorms, especially
                            where lightning strikes are probable.
                          </p>
                        </li>
                        <li>
                          <p>Dealing with explosions.</p>
                        </li>
                        <li>
                          <p>
                            Mitigating the impact of natural disasters like
                            floods, bushfires, or earthquakes.
                          </p>
                        </li>
                      </ul>
                      <p>
                        Moreover, the plan must consider workers who operate
                        across multiple worksites or workplaces.
                      </p>
                      <p className="py-5">
                        Additionally, the emergency plan should incorporate
                        compliance with relevant laws and government orders,
                        such as public health directives.
                      </p>
                      <p>
                        In shared workplaces like construction sites, shopping
                        centers, or multi-tenanted office buildings, there is an
                        obligation for organizations to engage in consultation
                        and cooperation to ensure a cohesive and coordinated
                        response.
                      </p>
                    </div>
                    <div className="d-block padding btn-block text-center">
                      <button type="button" onClick={() => nextsection("1")}>
                        CONTINUE
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          )}
          {lesson2 && (
            <section id="wrokers" className="intro w-100">
              <div className="d-flex flex-column">
                <Link
                  ref={snd}
                  to="#introd"
                  onClick={() => lessonInstruction("1")}
                  className="backpage text-center d-flex flex-column"
                >
                  <i className="far fa-angle-up"></i>
                  <h5>Lesson 1 Introduction And Legislation</h5>
                </Link>
                <div className="stop">
                  <button
                    type="button"
                    className="tbtn"
                    onClick={() => menubars()}
                  >
                    <i className="fal fa-bars" aria-hidden="true"></i>
                  </button>
                </div>
              </div>
              <div className="container-xxl px-0">
                <div className="row">
                  <div className="col-lg-10 offset-md-1">
                    <div className="d-flex flex-column gap-3 padding py-5 lesson-block intro">
                      <h4>Lesson 2 of 6</h4>
                      <h1>Worker Responsibilities</h1>
                      <div className="line"></div>
                    </div>
                  </div>
                  <div className="col-12">
                    <div className="border-line">
                      <div className="line-per"></div>
                    </div>
                  </div>
                  <div className="col-lg-10 offset-md-1">
                    <div className="d-flex flex-column gap-3 py-3 pt-md-5">
                      <p className="padding">
                        Workers bear several responsibilities to mitigate health
                        and safety risks associated with emergency situations.
                        These responsibilities entail ensuring that you:
                      </p>
                    </div>
                    <div
                      id="legal"
                      className="d-flex flex-column padding py-3 py-md-5 introdu"
                    >
                      <ul className="py-5 d-flex flex-column gap-3">
                        <li>
                          <p>
                            Engage proactively in the consultation process for
                            developing and implementing emergency procedures.
                          </p>
                        </li>
                        <li>
                          <p>
                            Familiarize yourself with all of the organization's
                            emergency response protocols and understand the
                            actions to be taken during emergencies. This
                            includes procedures for accommodating hearing,
                            vision, or mobility impaired individuals, shutting
                            down plant and equipment, and isolating power
                            sources as necessary.
                          </p>
                        </li>
                        <li>
                          <p>
                            Promptly respond to and cooperate with directions
                            provided during emergency situations.
                          </p>
                        </li>
                        <li>
                          <p>
                            Possess knowledge of how to operate fire alarms and
                            utilize portable firefighting equipment.
                          </p>
                        </li>
                        <li>
                          <p>
                            Obtain appropriate training in specialized emergency
                            response procedures, such as fire warden duties,
                            administering first aid, or using rescue equipment,
                            when required.
                          </p>
                        </li>
                        <li>
                          <p>
                            Receive relevant information, training, and
                            instruction regarding emergency procedures and their
                            safe implementation.
                          </p>
                        </li>
                        <li>
                          <p>
                            Avoid obstructing designated walkways, especially
                            evacuation routes and emergency exits.
                          </p>
                        </li>
                        <li>
                          <p>
                            Actively participate in testing emergency procedures
                            and comply with instructions provided during such
                            drills.
                          </p>
                        </li>
                        <li>
                          <p>
                            Take part in and maintain records, if instructed by
                            management, of emergency evacuation exercises.
                          </p>
                        </li>
                        <li>
                          <p>
                            Utilize any necessary personal protective equipment
                            (PPE) provided during the implementation of
                            workplace emergency procedures.
                          </p>
                        </li>
                        <li>
                          <p>
                            Engage in any post-incident follow-up processes,
                            which may involve investigations or interventions
                            aimed at minimizing the psychological impact of
                            incidents on workers, such as trauma counseling.
                          </p>
                        </li>
                      </ul>
                    </div>
                    <div className="d-block padding btn-block text-center">
                      <button type="button" onClick={() => nextsection("2")}>
                        CONTINUE
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          )}
          {lesson3 && (
            <section id="emergency" className="intro w-100">
              <div className="d-flex flex-column">
                <Link
                  ref={third}
                  to="#wrokers"
                  onClick={() => lessonInstruction("2")}
                  className="backpage text-center d-flex flex-column"
                >
                  <i className="far fa-angle-up"></i>
                  <h5>Lesson 2 Worker Responsibilities</h5>
                </Link>
                <div className="stop">
                  <button
                    type="button"
                    className="tbtn"
                    onClick={() => menubars()}
                  >
                    <i className="fal fa-bars" aria-hidden="true"></i>
                  </button>
                </div>
              </div>
              <div className="container-xxl px-0">
                <div className="row" ref={stepSecond}>
                  <div className="col-lg-10 offset-md-1">
                    <div className="d-flex flex-column gap-3 padding py-5 lesson-block intro">
                      <h4>Lesson 3 of 6</h4>
                      <h1>Awareness of Emergency Planning and Procedures</h1>
                      <div className="line"></div>
                    </div>
                  </div>
                  <div className="col-12">
                    <div className="border-line">
                      <div className="line-per"></div>
                    </div>
                  </div>
                  <div className="col-lg-10 offset-md-1">
                    <div className="d-flex flex-column gap-3 py-3 pt-md-5">
                      <p className="padding">
                        The potential emergencies that may arise in your
                        workplace are typically influenced by the nature of the
                        tasks performed and the organization's location.
                      </p>
                    </div>
                    <div
                      id="legal"
                      className="d-flex flex-column padding py-3 pt-md-5 introdu"
                    >
                      <p>
                        When establishing emergency protocols, the organization
                        must consider various factors, including:
                      </p>
                      <ul className="py-5 d-flex flex-column gap-3">
                        <li>
                          <p>The specific tasks conducted.</p>
                        </li>
                        <li>
                          <p>Identifiable hazards.</p>
                        </li>
                        <li>
                          <p>The size and layout of the premises.</p>
                        </li>
                        <li>
                          <p>
                            The demographic makeup of workers and other
                            individuals present.
                          </p>
                        </li>
                      </ul>
                      <p>
                        The Organisation must implement the emergency plan for
                        the workplace in the event of an emergency.
                      </p>
                      <h5 className="py-5">
                        Fire classNameification Categories
                      </h5>
                      <p>
                        Before learning how to effectively respond to
                        emergencies like fires, it's essential to understand the
                        various sources of fires and the types of firefighting
                        equipment that can aid in emergency situations.
                      </p>
                      <p>Fires are categorized into six groups:</p>
                      <ul className="py-5 d-flex flex-column gap-3">
                        <li>
                          <p>
                            <strong>className A:</strong> Involving carbonaceous
                            solids such as paper, wood, plastic, and cloth.
                          </p>
                        </li>
                        <li>
                          <p>
                            <strong>className B:</strong> Involving flammable
                            liquids like methylated spirits, petrol, and motor
                            oil.
                          </p>
                        </li>
                        <li>
                          <p>
                            <strong>className C:</strong> Involving flammable
                            gases such as propane, butane, and methane.
                          </p>
                        </li>
                        <li>
                          <p>
                            <strong>className D:</strong> Involving combustible
                            metals like aluminum, magnesium, and titanium.
                          </p>
                        </li>
                        <li>
                          <p>
                            <strong>className E:</strong> Involving energized
                            electrical equipment such as cables, appliances, and
                            equipment.
                          </p>
                        </li>
                        <li>
                          <p>
                            <strong>className F:</strong> Involving cooking fats
                            and oils.
                          </p>
                        </li>
                      </ul>
                      <div className="matches py-5 p-md-5">
                        <p>
                          Choose the fire type to the correct
                          classNameification:
                        </p>
                        <div className="match d-flex gap-3 py-5">
                          <ul className="d-flex flex-column gap-4">
                            <li className="position-relative">
                              <div className="match-content d-flex gap-4 align-items-center">
                                <div className="d-flex gap-4 align-items-center">
                                  <p>
                                    <strong>A.</strong>
                                  </p>

                                  <span>Wood</span>
                                </div>
                                <input
                                  className="form-check-input"
                                  type="checkbox"
                                  name="Wood"
                                  id="Wood"
                                  value="1"
                                  onChange={startfire_3}
                                  checked={woodvalue.includes("1")}
                                />
                              </div>
                            </li>
                            <li className="position-relative">
                              <div className="match-content d-flex gap-3 align-items-center">
                                <div className="d-flex gap-4 align-items-center">
                                  <p>
                                    <strong>B.</strong>
                                  </p>
                                  <span>Vegetable Oil</span>
                                </div>
                                <input
                                  className="form-check-input"
                                  type="checkbox"
                                  name="Wood"
                                  id="Vegetable"
                                  value="2"
                                  onChange={startfire_3}
                                  checked={woodvalue.includes("2")}
                                />
                              </div>
                            </li>
                            <li className="position-relative">
                              <div className="match-content d-flex gap-3 align-items-center">
                                <div className="d-flex gap-4 align-items-center">
                                  <p>
                                    <strong>E.</strong>
                                  </p>

                                  <span>Energised Electrical Equipment </span>
                                </div>
                                <input
                                  className="form-check-input"
                                  type="checkbox"
                                  name="Wood"
                                  id="Energised_Electrical"
                                  value="3"
                                  onChange={startfire_3}
                                  checked={woodvalue.includes("3")}
                                />
                              </div>
                            </li>
                            <li className="position-relative">
                              <div className="match-content d-flex gap-3 align-items-center">
                                <div className="d-flex gap-4 align-items-center">
                                  <p>
                                    <strong>F.</strong>
                                  </p>
                                  <span>Flammable Liquids </span>
                                </div>
                                <input
                                  className="form-check-input"
                                  type="checkbox"
                                  name="Wood"
                                  value="4"
                                  onChange={startfire_3}
                                  checked={woodvalue.includes("4")}
                                  id="Flammable"
                                />
                              </div>
                            </li>
                          </ul>
                          <ul className="d-flex flex-column gap-4">
                            <li className="position-relative">
                              <div className="match-content ps-4">
                                <p>className A</p>
                              </div>
                            </li>
                            <li className="position-relative">
                              <div className="match-content ps-4">
                                <p>className B</p>
                              </div>
                            </li>
                            <li className="position-relative">
                              <div className="match-content ps-4">
                                <p>className E</p>
                              </div>
                            </li>
                            <li className="position-relative">
                              <div className="match-content ps-4">
                                <p>className F</p>
                              </div>
                            </li>
                          </ul>
                        </div>
                        <div className="d-flex flex-column justify-content-center align-items-center">
                          {less_3_subbtn && (
                            <Link
                              to="javascript:void(0)"
                              onClick={() => checkSection()}
                              className="sub-btn"
                            >
                              <p>Submit</p>
                            </Link>
                          )}
                          {less_3_ans && (
                            <div className="d-flex flex-column justify-content-center align-items-center thanks py-4">
                              <div className="fail">
                                <i className="fal fa-times"></i>
                              </div>

                              <p>
                                <strong>Thanks for confirming!</strong>
                              </p>

                              {!corr_ans && (
                                <p className="py-4">
                                  Sorry please review your answers
                                </p>
                              )}
                              {corr_ans && (
                                <p className="py-4">Correct - Well done!</p>
                              )}
                              <div className="retry pt-5">
                                <i
                                  className="fal fa-redo"
                                  onClick={() => refreshsection_3()}
                                ></i>
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                    {less_3_ans && (
                      <div className="d-block padding btn-block text-center">
                        <button type="button" onClick={() => nextsection("3")}>
                          CONTINUE
                        </button>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </section>
          )}
          {lesson4 && (
            <section id="extinguisher" className="intro w-100">
              <div className="d-flex flex-column">
                <Link
                  ref={forth}
                  to="#emergency"
                  onClick={() => lessonInstruction("3")}
                  className="backpage text-center d-flex flex-column"
                >
                  <i className="far fa-angle-up"></i>
                  <h5>
                    Lesson 3 Awareness of Emergency Planning and Procedures
                  </h5>
                </Link>
                <div className="stop" ref={stepthird}>
                  <button
                    type="button"
                    className="tbtn"
                    onClick={() => menubars()}
                  >
                    <i className="fal fa-bars" aria-hidden="true"></i>
                  </button>
                </div>
              </div>
              <div className="container-xxl px-0">
                <div className="row">
                  <div className="col-lg-10 offset-md-1">
                    <div className="d-flex flex-column gap-3 padding py-5 lesson-block intro">
                      <h4>Lesson 4 of 6</h4>
                      <h1>The Fire Tetrahedron And Extinguisher Types</h1>
                      <div className="line"></div>
                    </div>
                  </div>
                  <div className="col-12">
                    <div className="border-line">
                      <div className="line-per"></div>
                    </div>
                  </div>
                  <div className="col-lg-10 offset-md-1">
                    <div className="d-flex flex-column gap-3 py-3 pt-md-5">
                      <p className="padding">
                        Each facet of the fire tetrahedron represents Fuel,
                        Heat, Oxygen, and Chemical Chain Reaction. Fire
                        extinguishers function by removing one or more of these
                        elements, effectively quelling the flames.
                      </p>
                    </div>
                    <div
                      id="legal"
                      className="d-flex flex-column padding py-3 py-md-5 introdu"
                    >
                      <p>
                        Elimination of any single crucial element will result in
                        the extinguishment of a fire. These four fundamental
                        elements include:
                      </p>
                      <ul className="py-5 d-flex flex-column gap-3">
                        <li>
                          <p>Oxygen, necessary to sustain combustion.</p>
                        </li>
                        <li>
                          <p>
                            Adequate heat to elevate the material to its
                            ignition temperature.
                          </p>
                        </li>
                        <li>
                          <p>Fuel or combustible material.</p>
                        </li>
                        <li>
                          <p>
                            Subsequent initiation of an exothermic chemical
                            chain reaction within the material.
                          </p>
                        </li>
                      </ul>
                      <p>
                        The process of combustion, or the commencement of a
                        fire, involves the oxidation of a fuel in the presence
                        of oxygen, accompanied by the emission of heat, light,
                        and other byproducts. For oxidation to occur, both a
                        reducing agent (the fuel) and an oxidizing agent
                        (typically oxygen) must be present. As heat is
                        introduced, the ignition source (fuel) and oxygen become
                        energized, initiating a chain reaction. This thermal
                        transfer propagates, emitting heat and/or light.
                      </p>

                      <p className="pt-4">
                        Understanding the elements integral to fire ignition and
                        propagation, as outlined by the fire tetrahedron, aids
                        in selecting the most effective approach to
                        extinguishing uncontrolled fires and reducing the
                        likelihood of escalation.
                      </p>
                      <h5>Fire Suppression Equipment</h5>
                      <p>
                        In workplaces with inherent fire risks, the presence of
                        fire suppression equipment is often mandated by law.
                        Portable fire extinguishers necessitate regular
                        inspection and maintenance by certified personnel. Key
                        considerations for these devices include, but are not
                        limited to:
                      </p>
                      <ul className="py-5 d-flex flex-column gap-3">
                        <li>
                          <p>
                            Appropriate selection of extinguisher type based on
                            location and potential fire hazards.
                          </p>
                        </li>
                        <li>
                          <p>
                            Clearance of at least one meter around the fire
                            extinguisher to prevent obstruction.
                          </p>
                        </li>
                        <li>
                          <p>
                            Placement of signage directly above the fire
                            extinguisher for clear identification.
                          </p>
                        </li>
                        <li>
                          <p>
                            Ensuring the integrity of cable ties and lock pins.
                          </p>
                        </li>
                        <li>
                          <p>
                            Regular checks for any damages to the fire
                            extinguisher.
                          </p>
                        </li>
                      </ul>
                      <p>
                        Records documenting inspections and maintenance
                        activities should be diligently maintained.
                      </p>
                      <p className="pt-4">
                        Any instances of missing or damaged extinguishers in the
                        workplace should be promptly reported to management.
                      </p>
                      <div className="fire-img pt-5">
                        <img
                          className="w-100 px-5"
                          src={require("../assets/ohs/images/fire.jpg")}
                          alt="img"
                        />
                      </div>
                      <h5 className="py-4">Types of Fire Extinguisher</h5>
                      <p>
                        Please provide the list of extinguishers you would like
                        me to review for their purpose and method of use.
                      </p>
                    </div>
                  </div>
                  <div className="d-block exting position-relative">
                    <div className="exting-img ps-5">
                      <img
                        className="w-100"
                        src={require("../assets/ohs/images/fire-ex.jpg")}
                        alt="img"
                      />
                    </div>
                  </div>

                  <div className="col-lg-10 offset-md-1">
                    <div
                      id="legal"
                      className="d-flex flex-column padding py-3 introdu"
                    >
                      <div className="row align-items-center">
                        <div className="col-lg-6 order-md-1">
                          <h5>Fire Blankets</h5>
                          <p>
                            Appropriate for confined fires and suffocating
                            flames. Functions by depriving oxygen. Always verify
                            that the fire blanket exceeds the size of the fire.
                            Hold the blanket in front of you, ensuring full
                            coverage for protection. This involves enveloping
                            your hands in the blanket to shield them. Maintain
                            coverage over fires for an extended period to thwart
                            re-ignition.
                          </p>
                        </div>
                        <div className="col-lg-6 order-md-0">
                          <div className="blanket-img">
                            <img
                              src={require("../assets/ohs/images/blanket.jpg")}
                              alt="img"
                            />
                          </div>
                        </div>
                      </div>
                      <div className="row align-items-center">
                        <div className="col-lg-6">
                          <h5>Fire Hoses/Fire Hose Reels</h5>
                          <ul>
                            <li>
                              <p>
                                The signage is positioned directly above the
                                fire hose.
                              </p>
                            </li>
                            <li>
                              <p>
                                Intended for rapid intervention in combating
                                fires during their initial phase.
                              </p>
                            </li>
                            <li>
                              <p>DO NOT utilize for electrical fires.</p>
                            </li>
                            <li>
                              <p>
                                Ensure a minimum clearance of one meter and
                                inspect the fire hose for any damages. Activate
                                the fire hose reel before approaching the fire.
                                Verify water availability at the nozzle.
                              </p>
                            </li>
                            <li>
                              <p>Ensure the nozzle or jet is closed.</p>
                            </li>
                            <li>
                              <p>
                                Pull on the hose; the reel should dispense the
                                hose as it unwinds.
                              </p>
                            </li>
                            <li>
                              <p>
                                Direct the nozzle towards the base of the fire
                                and turn it on to discharge water.
                              </p>
                            </li>
                          </ul>
                        </div>
                        <div className="col-lg-6">
                          <div className="blanket-img w-100">
                            <img
                              className="w-100"
                              src={require("../assets/ohs/images/fire-hoses.jpg")}
                              alt="img"
                            />
                          </div>
                        </div>
                      </div>
                      <div className="escape d-flex flex-column gap-2">
                        <h5>Escape and Evacuation Protocols</h5>
                        <p>
                          At all times, it is imperative that the entry and exit
                          points of the workplace are safe, ensuring that
                          individuals with special needs or disabilities can
                          enter and exit securely. To ensure the safety of
                          individuals with disabilities, including visitors, you
                          may be designated as a "buddy" to provide assistance
                          in case of emergencies.
                        </p>
                        <p>
                          During an emergency, occupants of the building will
                          evacuate using the most direct route available. All
                          staircases should be easily accessible to everyone,
                          including those with disabilities.
                        </p>
                        <p>
                          This is especially critical during emergency
                          situations. Therefore, entry and exit points should
                          have slip-resistant surfaces in both wet and dry
                          conditions. Aisles and walkways must remain
                          unobstructed by furniture or other objects at all
                          times.
                        </p>
                        <p>
                          In cases where it is necessary to clearly mark entry
                          and exit routes, particularly emergency exits, the
                          organization should consider delineating the routes
                          with permanent lines in white, yellow, or another
                          contrasting color, or using reflective markers.
                        </p>
                        <p>
                          Entry and exit routes, staircases, and walkways should
                          be adequately illuminated. Open sides of staircases
                          should be secured with an upper rail and a lower rail,
                          complete with a suitable handrail in accordance with
                          relevant building codes.
                        </p>
                        <p>
                          In the event of an emergency, it is crucial for all
                          workers to have a thorough understanding of evacuation
                          procedures, including primary and secondary escape
                          routes, identification of wardens, any special
                          requirements, and how to activate alarms. All
                          buildings must display signage directing individuals
                          to the nearest emergency exit, which should have been
                          covered during your induction.
                        </p>
                        <div className="green-men d-block">
                          <img
                            className="w-100"
                            src={require("../assets/ohs/images/green-men.jpg")}
                            alt="img"
                          />
                        </div>
                        <span> Example of a green running man sign </span>
                      </div>
                      <div className="py-5 d-flex justify-content-center align-items-center bg-light">
                        <div
                          className="card card-1 p-0 shadow"
                          style={{ maxWidth: "100%" }}
                        >
                          <nav>
                            <div
                              className="nav nav-tabs mb-3 nav-fill"
                              id="nav-tab1"
                              role="tablist"
                            >
                              <button
                                className={`nav-link ${tabsectionView === "Tab1" ? "active" : ""
                                  } `}
                                id="nav-home-tab1"
                                data-bs-toggle="tab"
                                data-bs-target="#nav-home1"
                                type="button"
                                role="tab"
                                aria-controls="nav-home"
                                aria-selected="true"
                                onClick={() => tabReview_4("Tab1")}
                              >
                                Escape
                              </button>
                              <button
                                className={`nav-link ${tabsectionView === "Tab2" ? "active" : ""
                                  } `}
                                id="nav-profile-tab2"
                                data-bs-toggle="tab"
                                data-bs-target="#nav-profile2"
                                type="button"
                                role="tab"
                                aria-controls="nav-profile"
                                aria-selected="false"
                                tabindex="-1"
                                onClick={() => tabReview_4("Tab2")}
                              >
                                Layout And Routes
                              </button>
                              <button
                                className={`nav-link ${tabsectionView === "Tab3" ? "active" : ""
                                  } `}
                                id="nav-contact-tab3"
                                data-bs-toggle="tab"
                                data-bs-target="#nav-contact3"
                                type="button"
                                role="tab"
                                aria-controls="nav-contact"
                                aria-selected="false"
                                tabindex="-1"
                                onClick={() => tabReview_4("Tab3")}
                              >
                                Means Of Escape
                              </button>
                              <button
                                className={`nav-link ${tabsectionView === "Tab4" ? "active" : ""
                                  } `}
                                id="nav-green-tab4"
                                data-bs-toggle="tab"
                                data-bs-target="#nav-green4"
                                type="button"
                                role="tab"
                                aria-controls="nav-green4"
                                aria-selected="false"
                                tabindex="-1"
                                onClick={() => tabReview_4("Tab4")}
                              >
                                Emergency Lighting
                              </button>
                            </div>
                          </nav>
                          <div
                            className="tab-content p-4 bg-light"
                            id="nav-tabContent"
                          >
                            <div
                              className={`tab-pane fade ${tabsectionView === "Tab1" ? "active show" : ""
                                } `}
                              id="nav-home1"
                              role="tabpanel"
                              aria-labelledby="nav-home-tab1"
                            >
                              <p>
                                A designated area of relative safety, commonly
                                referred to as a muster or assembly point,
                                serves as a location where evacuees can seek
                                refuge from the immediate dangers of an
                                emergency until rescue operations can be carried
                                out. The chosen assembly point should be
                                carefully selected and highlighted on plans,
                                considering the following factors:
                              </p>
                              <ul>
                                <li>
                                  <p>
                                    Accessibility to the muster or assembly
                                    point.
                                  </p>
                                </li>
                                <li>
                                  <p>Structural integrity for protection.</p>
                                </li>
                                <li>
                                  <p>Adequate ventilation.</p>
                                </li>
                                <li>
                                  <p>
                                    Lighting and clear signage for visibility.
                                  </p>
                                </li>
                                <li>
                                  <p>Availability of communication devices.</p>
                                </li>
                              </ul>
                              <p>
                                The muster or assembly point should be situated
                                a sufficient distance away from the building to
                                mitigate risks from flying debris or potential
                                explosions. Ideally, it should be accessible
                                without the need to traverse active roads or
                                thoroughfares.
                              </p>
                              <p>
                                Furthermore, the assembly point must not impede
                                the entry pathways required for emergency
                                services to access the premises.
                              </p>
                              <div className="acc-img1 py-3">
                                <img
                                  className="w-100"
                                  src={require("../assets/ohs/images/escap.png")}
                                  alt="img"
                                />
                              </div>
                            </div>
                            <div
                              className={`tab-pane fade ${tabsectionView === "Tab2" ? "active show" : ""
                                } `}
                              id="nav-profile2"
                              role="tabpanel"
                              aria-labelledby="nav-profile-tab2"
                            >
                              <p>
                                Make sure you are acquainted with the layout and
                                exit routes of your workplace. These details are
                                typically found on an evacuation map or plan,
                                often displayed near emergency exits and in
                                prominent areas throughout the workplace.
                              </p>
                              <p>
                                Familiarize yourself with these details for the
                                specific area where you are working.
                              </p>
                              <div className="acc-img1 py-3">
                                <img
                                  className="w-100"
                                  src={require("../assets/ohs/images/map.png")}
                                  alt="img"
                                />
                              </div>
                            </div>
                            <div
                              className={`tab-pane fade ${tabsectionView === "Tab3" ? "active show" : ""
                                } `}
                              id="nav-contact3"
                              role="tabpanel"
                              aria-labelledby="nav-contact-tab3"
                            >
                              <p>
                                Ensure you can navigate the means of escape or
                                exit, bearing in mind that some routes, such as
                                stairwells, may have restricted access.
                              </p>
                              <p>
                                The organization is responsible for developing a
                                Personal Emergency Evacuation Plan (PEEP) for
                                individuals who cannot use these routes, such as
                                those with mobility impairments. Nevertheless,
                                you may be called upon to provide assistance to
                                such individuals, necessitating awareness of
                                their individual plan.
                              </p>
                              <div className="acc-img1 py-3">
                                <img
                                  className="w-100"
                                  src={require("../assets/ohs/images/stair.png")}
                                  alt="img"
                                />
                              </div>
                            </div>
                            <div
                              className={`tab-pane fade ${tabsectionView === "Tab4" ? "active show" : ""
                                } `}
                              id="nav-green4"
                              role="tabpanel"
                              aria-labelledby="nav-green-tab4"
                            >
                              <p>
                                Emergency lighting should activate automatically
                                if the mains electricity fails, aiming to offer
                                a visible pathway during emergencies.
                              </p>
                              <p>
                                Various lux levels might be necessary, depending
                                on the business activities conducted at the
                                premises or the individuals present.
                              </p>
                              <div className="acc-img1 py-3">
                                <img
                                  className="w-100"
                                  src={require("../assets/ohs/images/sign.png")}
                                  alt="img"
                                />
                              </div>
                            </div>
                            <div
                              className={`tab-pane fade ${tabsectionView === "Tab5" ? "active show" : ""
                                } `}
                              id="nav-red"
                              role="tabpanel"
                              aria-labelledby="nav-red-tab"
                            >
                              <p>
                                Red is also employed to indicate fire-fighting
                                equipment, including extinguishers, and to
                                denote the location of such equipment. These
                                signs are presented in either a square or
                                rectangle shape.
                              </p>
                              <div className="acc-img1 py-3">
                                <img
                                  className="w-100"
                                  src={require("../assets/ohs/images/red1.png")}
                                  alt="img"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    {tabsectionView_4 && (
                      <div className="col-lg-10 offset-md-1 pt-5">
                        <div className="d-block btn-block text-center">
                          <button
                            type="button"
                            onClick={() => nextsection("4")}
                          >
                            CONTINUE
                          </button>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </section>
          )}
          {lesson5 && (
            <section id="respond" className="intro w-100">
              <div className="d-flex flex-column">
                <Link
                  ref={fifth}
                  to="#extinguisher"
                  onClick={() => lessonInstruction("4")}
                  className="backpage text-center d-flex flex-column"
                >
                  <i className="far fa-angle-up"></i>
                  <h5>Lesson 4 The Fire Tetrahedron And Extinguisher Types</h5>
                </Link>
                <div className="stop">
                  <button
                    type="button"
                    className="tbtn"
                    onClick={() => menubars()}
                  >
                    <i className="fal fa-bars" aria-hidden="true"></i>
                  </button>
                </div>
              </div>
              <div className="container-xxl px-0" ref={stepforth}>
                <div className="row">
                  <div className="col-lg-10 offset-md-1">
                    <div className="d-flex flex-column gap-3 padding py-5 lesson-block intro">
                      <h4>Lesson 5 of 6</h4>
                      <h1>How To Respond To An Emergency</h1>
                      <div className="line"></div>
                    </div>
                  </div>
                  <div className="col-12">
                    <div className="border-line">
                      <div className="line-per"></div>
                    </div>
                  </div>
                  <div className="col-lg-10 offset-md-1">
                    <div
                      id="legal"
                      className="d-flex flex-column padding py-3 py-md-5 introdu gap-2"
                    >
                      <h5>Fire Wardens</h5>
                      <p>
                        While health and safety legislation may not explicitly
                        mandate the presence of fire wardens, an effective
                        emergency plan or procedure typically requires
                        designated individuals with defined roles and
                        responsibilities. Trained fire wardens play a crucial
                        role in enhancing emergency evacuations by ensuring
                        adherence to proper procedures and accounting for
                        everyone's safety.
                      </p>
                      <p>
                        Therefore, it is essential for the organization to
                        appoint at least one fire warden, considering the
                        possibility of additional floor or area/zone wardens,
                        commonly known as deputy wardens.
                      </p>
                      <p>
                        Fire wardens and deputy wardens, nominated and trained
                        as competent individuals, possess the expertise to
                        implement fire safety measures and provide guidance on
                        appropriate procedures during emergencies.
                      </p>
                      <p>
                        Preferably, fire wardens and deputy wardens should
                        undergo training conducted by reputable providers. This
                        training should be tailored to address specific
                        workplace hazards, such as hazardous substances or
                        remote working conditions, enabling them to effectively
                        manage emergency situations in the workplace.
                      </p>
                      <div className="row align-items-center py-5">
                        <div className="col-lg-6 order-md-1">
                          <h5>Warden Responsibilities</h5>
                          <ul>
                            <li>
                              <p>
                                Regularly communicate emergency procedures and
                                plans to workers.
                              </p>
                            </li>
                            <li>
                              <p>
                                Oversee the maintenance of fire safety
                                installations and systems, including conducting
                                routine inspections of firefighting equipment.
                              </p>
                            </li>
                            <li>
                              <p>Report any unsafe conditions or concerns.</p>
                            </li>
                            <li>
                              <p>
                                Document incidents and near misses related to
                                emergency preparedness.
                              </p>
                            </li>
                            <li>
                              <p>
                                Coordinate and participate in command and
                                control procedures during emergency drills.
                              </p>
                            </li>
                            <li>
                              <p>
                                Conduct post-emergency drill feedback sessions
                                or debriefings.
                              </p>
                            </li>
                          </ul>
                        </div>
                        <div className="col-lg-6 order-md-0">
                          <div className="blanket-img">
                            <img
                              src={require("../assets/ohs/images/warden.png")}
                              alt="img"
                            />
                          </div>
                        </div>
                      </div>
                      <div id="carouselExample" className="carousel slide py-5">
                        <div className="carousel-inner">
                          <Slider {...settings}>
                            <div className="carousel-item active">
                              <div className="silder-box2">
                                <div className="steps">
                                  <Link to="#">Step 1</Link>
                                </div>
                                <h1 className="py-2">
                                  When the alarm is activated
                                </h1>
                                <div className="d-flex justify-content-center">
                                  <div className="d-block py-3">
                                    <img
                                      src={require("../assets/ohs/images/alarm-sound.png")}
                                      className="d-block w-100"
                                      alt="..."
                                    />
                                  </div>
                                </div>
                                <p>
                                  Ensure visibility! It is advisable for all
                                  fire wardens to wear a high-visibility vest
                                  and a hard hat to enhance their visibility.
                                  Provide instructions and guidance to
                                  individuals in accordance with the evacuation
                                  procedure.
                                </p>
                              </div>
                            </div>
                            <div className="carousel-item">
                              <div className="silder-box2">
                                <div className="steps">
                                  <Link to="#">Step 2</Link>
                                </div>
                                <h1 className="py-2">Check The Area</h1>
                                <div className="d-flex justify-content-center">
                                  <div className="d-block py-3">
                                    <img
                                      src={require("../assets/ohs/images/check-area.png")}
                                      className="d-block w-100"
                                      alt="img"
                                    />
                                  </div>
                                </div>
                                <ul>
                                  <li>
                                    <p>
                                      Ensure that the premises is evacuated -
                                      check all rooms - including common areas
                                      such as toilets or store rooms. Most
                                      training providers recommend a common
                                      identifier be used to identify areas
                                      already checked such as a chalk “X” on the
                                      door.
                                    </p>
                                  </li>
                                  <li>
                                    <p>
                                      Help people leave the premises who may
                                      need further assistance.
                                    </p>
                                  </li>
                                  <li>
                                    <p>
                                      Be the last to leave; however, do not
                                      endanger yourself if the fire is close or
                                      impeding your exit route.
                                    </p>
                                  </li>
                                </ul>
                              </div>
                            </div>
                            <div className="carousel-item">
                              <div className="silder-box2">
                                <div className="steps">
                                  <Link to="#">Step 3</Link>
                                </div>
                                <h1 className="py-2">Communicate</h1>
                                <div className="d-flex justify-content-center">
                                  <div className="d-block py-3">
                                    <img
                                      src={require("../assets/ohs/images/comm.png")}
                                      className="d-block w-100"
                                      alt="..."
                                    />
                                  </div>
                                </div>
                                <p>
                                  Coordinate with other wardens or the incident
                                  controller, if applicable. If safe, retrieve
                                  daily sign-in or electronic access records to
                                  aid in identifying individuals not yet
                                  accounted for. Conduct a head count to ensure
                                  all persons are present. Ensure a first aid
                                  kit and a trained first aid attendant are
                                  available at the muster or assembly point to
                                  provide treatment if needed. Inform Emergency
                                  Services if any individuals remain unaccounted
                                  for.
                                </p>
                              </div>
                            </div>
                            <div className="carousel-item">
                              <div className="silder-box2">
                                <div className="steps">
                                  <Link to="#">Step 4</Link>
                                </div>
                                <h1 className="py-2">Emergency Services</h1>
                                <div className="d-flex justify-content-center">
                                  <div className="d-block py-3">
                                    <img
                                      src={require("../assets/ohs/images/men-w.png")}
                                      className="d-block w-100"
                                      alt="..."
                                    />
                                  </div>
                                </div>
                                <p>
                                  Coordinate with Emergency Services as needed:
                                </p>
                                <p>
                                  Furnish them with details regarding the fire's
                                  location. Inform them of any missing
                                  individuals or individuals located in muster
                                  or assembly areas requiring assistance.
                                </p>
                              </div>
                            </div>
                          </Slider>
                        </div>
                      </div>
                      <div
                        id="carouselExample1"
                        className="carousel slide py-5"
                      >
                        <div className="carousel-inner">
                          <Slider {...settings_2}>
                            <div className="carousel-item active">
                              <div className="silder-box2">
                                <div className="steps">
                                  <Link to="#">Step 1</Link>
                                </div>
                                <h1 className="py-2">When The Alarm Sounds</h1>
                                <div className="d-flex justify-content-center">
                                  <div className="d-block py-3">
                                    <img
                                      src={require("../assets/ohs/images/alarm-sound.png")}
                                      className="d-block w-100"
                                      alt="..."
                                    />
                                  </div>
                                </div>
                                <ul>
                                  <li>
                                    <p>
                                      Obey the guidance provided by your fire
                                      warden or floor warden.
                                    </p>
                                  </li>
                                  <li>
                                    <p>
                                      Promptly exit through the closest
                                      emergency exit or the one designated by
                                      your warden, making your way to the
                                      nearest evacuation assembly point.
                                    </p>
                                  </li>
                                  <li>
                                    <p>
                                      Refrain from using any available
                                      elevators. Stay calm, walk calmly, and
                                      leave personal belongings behind while
                                      evacuating to ensure a smooth process.
                                    </p>
                                  </li>
                                </ul>
                              </div>
                            </div>
                            <div className="carousel-item">
                              <div className="silder-box2">
                                <div className="steps">
                                  <Link to="#">Step 2</Link>
                                </div>
                                <h1 className="py-2">
                                  Check The Safety Of People In The Immediate
                                  Vicinity
                                </h1>
                                <div className="d-flex justify-content-center">
                                  <div className="d-block py-3">
                                    <img
                                      src={require("../assets/ohs/images/check-area.png")}
                                      className="d-block w-100"
                                      alt="img"
                                    />
                                  </div>
                                </div>
                                <ul>
                                  <li>
                                    <p>
                                      Assist individuals who require additional
                                      help during the evacuation process.
                                    </p>
                                  </li>
                                  <li>
                                    <p>
                                      Avoid putting yourself at risk if the fire
                                      is nearby or obstructing your path to
                                      safety.
                                    </p>
                                  </li>
                                  <li>
                                    <p>
                                      Seek first aid assistance from the
                                      designated first aid attendant if
                                      necessary.
                                    </p>
                                  </li>
                                </ul>
                              </div>
                            </div>
                            <div className="carousel-item">
                              <div className="silder-box2">
                                <div className="steps">
                                  <Link to="#">Step 3</Link>
                                </div>
                                <h1 className="py-2">Communicate</h1>
                                <div className="d-flex justify-content-center">
                                  <div className="d-block py-3">
                                    <img
                                      src={require("../assets/ohs/images/comm.png")}
                                      className="d-block w-100"
                                      alt="..."
                                    />
                                  </div>
                                </div>
                                <p>
                                  Inform a fire warden or Emergency Services
                                  about any individuals who are missing or in
                                  need of assistance.
                                </p>
                              </div>
                            </div>
                            <div className="carousel-item">
                              <div className="silder-box2">
                                <div className="steps">
                                  <Link to="#">Step 4</Link>
                                </div>
                                <h1 className="py-2">
                                  Wait For Further Instructions
                                </h1>
                                <div className="d-flex justify-content-center">
                                  <div className="d-block py-3">
                                    <img
                                      src={require("../assets/ohs/images/men-w.png")}
                                      className="d-block w-100"
                                      alt="..."
                                    />
                                  </div>
                                </div>

                                <p>
                                  Wait to re-enter the building or work area
                                  until it has been confirmed safe by the fire
                                  warden or Emergency Services.
                                </p>
                              </div>
                            </div>
                          </Slider>
                        </div>
                      </div>
                      <div
                        id="carouselExample2"
                        className="carousel slide py-5"
                      >
                        <div className="carousel-inner">
                          <Slider {...settings_3}>
                            <div className="carousel-item active">
                              <div className="silder-box2">
                                <div className="steps">
                                  <Link to="#">Step 1</Link>
                                </div>
                                <h1 className="py-2">
                                  In the event of a medical emergency
                                </h1>
                                <div className="d-flex justify-content-center">
                                  <div className="d-block py-3">
                                    <img
                                      src={require("../assets/ohs/images/medical1.png")}
                                      className="d-block w-100"
                                      alt="..."
                                    />
                                  </div>
                                </div>
                                <ul>
                                  <li>
                                    <p>
                                      Assess the situation to ensure personnel
                                      safety.
                                    </p>
                                  </li>
                                  <li>
                                    <p>
                                      Summon help from others in the immediate
                                      vicinity, or a nominated first aid
                                      attendant.
                                    </p>
                                  </li>
                                  <li>
                                    <p>
                                      Do not leave the affected person unless it
                                      is unavoidable.
                                    </p>
                                  </li>
                                </ul>
                              </div>
                            </div>
                            <div className="carousel-item">
                              <div className="silder-box2">
                                <div className="steps">
                                  <Link to="#">Step 2</Link>
                                </div>
                                <h1 className="py-2">Sound the alarm</h1>
                                <div className="d-flex justify-content-center">
                                  <div className="d-block py-3">
                                    <img
                                      src={require("../assets/ohs/images/em-alarm.png")}
                                      className="d-block w-100"
                                      alt="img"
                                    />
                                  </div>
                                </div>
                                <p>
                                  let the authorities and reach out to Emergency
                                  Services. Offer precise guidance to Emergency
                                  Services regarding:
                                </p>
                                <ul>
                                  <li>
                                    <p>
                                      The worker's location and directions to
                                      the workplace.
                                    </p>
                                  </li>
                                  <li>
                                    <p>
                                      Specifics about the casualty (such as the
                                      nature of the injury, the worker's age,
                                      and their condition).
                                    </p>
                                  </li>
                                  <li>
                                    <p>
                                      The time the injury or illness occurred.
                                      Ensure you remain on the line until the
                                      operator confirms they have all necessary
                                      information.
                                    </p>
                                  </li>
                                </ul>
                              </div>
                            </div>
                            <div className="carousel-item">
                              <div className="silder-box2">
                                <div className="steps">
                                  <Link to="#">Step 3</Link>
                                </div>
                                <h1 className="py-2">
                                  Adhere to reporting protocols
                                </h1>
                                <div className="d-flex justify-content-center">
                                  <div className="d-block py-3">
                                    <img
                                      src={require("../assets/ohs/images/doc.png")}
                                      className="d-block w-100"
                                      alt="..."
                                    />
                                  </div>
                                </div>
                                <p>
                                  Notify your manager and/or fill out an
                                  incident report form according to internal
                                  procedures. You might be asked to contribute
                                  to an investigation of the emergency.
                                </p>
                              </div>
                            </div>
                          </Slider>
                        </div>
                      </div>
                      <p>
                        Make sure you receive relevant information,
                        instructions, training, and supervision regarding all
                        emergency procedures specific to your workplace. If you
                        have any queries, reach out to your manager for
                        clarification.
                      </p>
                    </div>
                  </div>
                  {btn_3 && (
                    <div className="col-lg-10 offset-md-1 py-5">
                      <div className="d-block padding btn-block text-center">
                        <button type="button" onClick={() => nextsection("5")}>
                          CONTINUE
                        </button>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </section>
          )}
          {lesson6 && (
            <section id="assessment" className="human w-100">
              <div className="d-flex flex-column">
                <Link
                  ref={sixth}
                  to="#respond"
                  onClick={() => lessonInstruction("5")}
                  className="backpage text-center d-flex flex-column"
                >
                  <i className="far fa-angle-up"></i>
                  <h5>Lesson 5 How To Respond To An Emergency</h5>
                </Link>
              </div>
              <div className="container-xxl px-0">
                <div className="row">
                  <div className="col-lg-10 offset-md-1">
                    <div className="d-flex flex-column gap-3 padding py-5 lesson-block intro">
                      <h4>Lesson 6 of 6</h4>
                      <h1>Final Assessment</h1>
                      <div className="line" style={{ width: "100%" }}></div>
                    </div>
                  </div>
                  <div className="col-12">
                    <div className="border-line">
                      <div className="line-per"></div>
                    </div>
                  </div>
                  <form action="javascript:void(0)">
                    <div className="col-lg-10 offset-md-1 padding py-5">
                      {sec_1 && (
                        <div className="d-flex flex-column gap-5 fullname-block text-center py-5">
                          <h4>
                            Please enter your FULL NAME before you continue:
                          </h4>
                          <div className="d-flex justify-content-center name-form">
                            <div className="d-flex gap-2">
                              <div className="flex-grow-1">
                                <input
                                  type="text"
                                  name=""
                                  id=""
                                  required
                                  onInput={entername_6}
                                  ref={inputRef}
                                  placeholder="Type your name here..."
                                />
                              </div>
                              <div className="flex-shrink-0">
                                <button type="submit" onClick={btn_entername}>
                                  Continue
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                      {quizless_6_1 && (
                        <div className="d-flex flex-column py-5 fullname-block">
                          <h4>
                            What are the four elements of the fire tetrahedron?
                          </h4>

                          <div className="d-flex flex-column mt-4 gap-4 name-form">
                            <h5>Please select the correct answer:</h5>
                            <div
                              className={`form-check ${isOpacity_6 ? " opacityy" : ""
                                }`}
                            >
                              <div class="position-relative">
                                <input
                                  className="form-check-input"
                                  type="radio"
                                  name="q1"
                                  id="Heat"
                                  checked={checkQ_6_1 === "Heat"}
                                  onChange={() => startQuiz_6_1("Heat")}
                                />
                                {isfirstquiz_6_1 &&
                                  (issetQuizAns_6_1_btn === "Heat" ? (
                                    <div className="check">
                                      <i className="fas fa-check text-success"></i>
                                    </div>
                                  ) : (
                                    <div className="check1">
                                      <i className="fas fa-times text-fail"></i>
                                    </div>
                                  ))}
                              </div>
                              <label className="form-check-label" for="Heat">
                                Heat
                              </label>
                            </div>
                            <div
                              className={`form-check ${isOpacity_6 ? " opacityy" : ""
                                }`}
                            >
                              <div class="position-relative">
                                <input
                                  className="form-check-input"
                                  type="radio"
                                  name="q1"
                                  id="Chemical_chain"
                                  checked={checkQ_6_1 === "Chemical_chain"}
                                  onChange={() =>
                                    startQuiz_6_1("Chemical_chain")
                                  }
                                />
                                {isfirstquiz_6_1 &&
                                  (issetQuizAns_6_1_btn === "Chemical_chain" ? (
                                    <div className="check">
                                      <i className="fas fa-check text-success"></i>
                                    </div>
                                  ) : (
                                    <div className="check1">
                                      <i className="fas fa-times text-fail"></i>
                                    </div>
                                  ))}
                              </div>
                              <label
                                className="form-check-label"
                                for="Chemical_chain"
                              >
                                Chemical Chain Reaction
                              </label>
                            </div>
                            <div
                              className={`form-check ${isOpacity_6 ? " opacityy" : ""
                                }`}
                            >
                              <div class="position-relative">
                                <input
                                  className="form-check-input"
                                  type="radio"
                                  name="q1"
                                  id="Oxygen"
                                  checked={checkQ_6_1 === "Oxygen"}
                                  onChange={() => startQuiz_6_1("Oxygen")}
                                />
                                {isfirstquiz_6_1 &&
                                  (issetQuizAns_6_1_btn === "Oxygen" ? (
                                    <div className="check">
                                      <i className="fas fa-check text-success"></i>
                                    </div>
                                  ) : (
                                    <div className="check1">
                                      <i className="fas fa-times text-fail"></i>
                                    </div>
                                  ))}
                              </div>
                              <label className="form-check-label" for="Oxygen">
                                Oxygen
                              </label>
                            </div>
                            <div
                              className={`form-check ${isOpacity_6 ? " opacityy" : ""
                                }`}
                            >
                              <div class="position-relative">
                                <input
                                  className="form-check-input"
                                  type="radio"
                                  name="q1"
                                  id="Fuel"
                                  checked={checkQ_6_1 === "Fuel"}
                                  onChange={() => startQuiz_6_1("Fuel")}
                                />
                                {isfirstquiz_6_1 &&
                                  (issetQuizAns_6_1_btn === "Fuel" ? (
                                    <div className="check">
                                      <i className="fas fa-check text-success"></i>
                                    </div>
                                  ) : (
                                    <div className="check1">
                                      <i className="fas fa-times text-fail"></i>
                                    </div>
                                  ))}
                              </div>
                              <label className="form-check-label" for="Fuel">
                                Fuel
                              </label>
                            </div>
                            {worngansQuiz_6_1 && (
                              <div className="d-flex justify-content-center">
                                <div className="text-center">
                                  <Link to="javascript:void(0)" className="">
                                    <i class="fas fa-times"></i>
                                  </Link>
                                  <p>
                                    <strong>Thanks for confirmation</strong>
                                  </p>
                                  <p>Sorry that's not correct.</p>
                                </div>
                              </div>
                            )}
                            {rightansQuiz_6_1 && (
                              <div className="d-flex justify-content-center">
                                <div className="text-center">
                                  <Link to="javascript:void(0)" className="">
                                    <i class="fas fa-check"></i>
                                  </Link>
                                  <p>
                                    <strong>Thanks for confirmation</strong>
                                  </p>
                                  <p>That's correct - well done.</p>
                                </div>
                              </div>
                            )}
                            {q1_6_next && (
                              <div className="d-flex justify-content-center">
                                <button
                                  type="button"
                                  onClick={() => Quiz_next_6("1")}
                                >
                                  Next
                                </button>
                              </div>
                            )}
                            {checkbtn_quiz_1_6 && (
                              <div className="d-flex justify-content-end">
                                <button
                                  type="button"
                                  onClick={() => Quiz_check_6("1")}
                                >
                                  Submit
                                </button>
                              </div>
                            )}
                          </div>
                        </div>
                      )}
                      {quizless_6_2 && (
                        <div className="d-flex flex-column py-5 fullname-block">
                          <h4>What is not a class of fire?</h4>

                          <div className="d-flex flex-column mt-4 gap-4 name-form">
                            <h5>Please select the correct answer:</h5>
                            <div
                              className={`form-check  ${isOpacity_6_1 ? " opacityy" : ""
                                }`}
                            >
                              <div class="position-relative">
                                <input
                                  className="form-check-input"
                                  type="radio"
                                  name="q2"
                                  id="Class_H"
                                  checked={checkQ_6_2 === "Class_H"}
                                  onChange={() => startQuiz_6_2("Class_H")}
                                />
                                {isfirstquiz_6_2 &&
                                  (issetQuizAns_6_2_btn === "Class_H" ? (
                                    <div className="check">
                                      <i className="fas fa-check text-success"></i>
                                    </div>
                                  ) : (
                                    <div className="check1">
                                      <i className="fas fa-times text-fail"></i>
                                    </div>
                                  ))}
                              </div>
                              <label className="form-check-label" for="Class_H">
                                Class H
                              </label>
                            </div>
                            <div
                              className={`form-check ${isOpacity_6_1 ? " opacityy" : ""
                                }`}
                            >
                              <div class="position-relative">
                                <input
                                  className="form-check-input"
                                  type="radio"
                                  name="q2"
                                  id="Class_D"
                                  checked={checkQ_6_2 === "Class_D"}
                                  onChange={() => startQuiz_6_2("Class_D")}
                                />
                                {isfirstquiz_6_2 &&
                                  (issetQuizAns_6_2_btn === "Class_D" ? (
                                    <div className="check">
                                      <i className="fas fa-check text-success"></i>
                                    </div>
                                  ) : (
                                    <div className="check1">
                                      <i className="fas fa-times text-fail"></i>
                                    </div>
                                  ))}
                              </div>
                              <label className="form-check-label" for="Class_D">
                                Class D
                              </label>
                            </div>
                            <div
                              className={`form-check ${isOpacity_6_1 ? " opacityy" : ""
                                }`}
                            >
                              <div class="position-relative">
                                <input
                                  className="form-check-input"
                                  type="radio"
                                  name="q2"
                                  id="Class_A"
                                  checked={checkQ_6_2 === "Class_A"}
                                  onChange={() => startQuiz_6_2("Class_A")}
                                />
                                {isfirstquiz_6_2 &&
                                  (issetQuizAns_6_2_btn === "Class_A" ? (
                                    <div className="check">
                                      <i className="fas fa-check text-success"></i>
                                    </div>
                                  ) : (
                                    <div className="check1">
                                      <i className="fas fa-times text-fail"></i>
                                    </div>
                                  ))}
                              </div>
                              <label className="form-check-label" for="Class_A">
                                Class A
                              </label>
                            </div>
                            <div
                              className={`form-check ${isOpacity_6_1 ? " opacityy" : ""
                                }`}
                            >
                              <div class="position-relative">
                                <input
                                  className="form-check-input"
                                  type="radio"
                                  name="q2"
                                  id="Class_F"
                                  checked={checkQ_6_2 === "Class_F"}
                                  onChange={() => startQuiz_6_2("Class_F")}
                                />
                                {isfirstquiz_6_2 &&
                                  (issetQuizAns_6_2_btn === "Class_F" ? (
                                    <div className="check">
                                      <i className="fas fa-check text-success"></i>
                                    </div>
                                  ) : (
                                    <div className="check1">
                                      <i className="fas fa-times text-fail"></i>
                                    </div>
                                  ))}
                              </div>
                              <label className="form-check-label" for="Class_F">
                                Class F
                              </label>
                            </div>
                            {worngansQuiz_6_1 && (
                              <div className="d-flex justify-content-center">
                                <div className="text-center">
                                  <Link to="javascript:void(0)" className="">
                                    <i class="fas fa-times"></i>
                                  </Link>
                                  <p>
                                    <strong>Thanks for confirmation</strong>
                                  </p>
                                  <p>Sorry that's not correct.</p>
                                </div>
                              </div>
                            )}
                            {rightansQuiz_6_1 && (
                              <div className="d-flex justify-content-center">
                                <div className="text-center">
                                  <Link to="javascript:void(0)" className="">
                                    <i class="fas fa-check"></i>
                                  </Link>
                                  <p>
                                    <strong>Thanks for confirmation</strong>
                                  </p>
                                  <p>That's correct - well done.</p>
                                </div>
                              </div>
                            )}
                            {q2_6_next && (
                              <div className="d-flex justify-content-center">
                                <button
                                  type="button"
                                  onClick={() => Quiz_next_6("2")}
                                >
                                  Next
                                </button>
                              </div>
                            )}
                            {checkbtn_quiz_2_6 && (
                              <div className="d-flex justify-content-end">
                                <button
                                  type="button"
                                  onClick={() => Quiz_check_6("2")}
                                >
                                  Submit
                                </button>
                              </div>
                            )}
                          </div>
                        </div>
                      )}
                      {quizless_6_3 && (
                        <div className="d-flex flex-column py-5 fullname-block">
                          <h4>Which is not a fire control measure?</h4>

                          <div className="d-flex flex-column mt-4 gap-4 name-form">
                            <h5>Please select the correct answer:</h5>
                            <div
                              className={`form-check ${isOpacity_6_1 ? " opacityy" : ""
                                }`}
                            >
                              <div class="position-relative">
                                <input
                                  className="form-check-input"
                                  type="radio"
                                  name="q3"
                                  id="Fire_alarm"
                                  checked={checkQ_6_3 === "Fire_alarm"}
                                  onChange={() => startQuiz_6_3("Fire_alarm")}
                                />
                                {isfirstquiz_6_3 &&
                                  (issetQuizAns_6_3_btn === "Fire_alarm" ? (
                                    <div className="check">
                                      <i className="fas fa-check text-success"></i>
                                    </div>
                                  ) : (
                                    <div className="check1">
                                      <i className="fas fa-times text-fail"></i>
                                    </div>
                                  ))}
                              </div>
                              <label
                                className="form-check-label"
                                for="Fire_alarm"
                              >
                                Fire Alarm
                              </label>
                            </div>
                            <div
                              className={`form-check ${isOpacity_6_1 ? " opacityy" : ""
                                }`}
                            >
                              <div class="position-relative">
                                <input
                                  className="form-check-input"
                                  type="radio"
                                  name="q3"
                                  id="Voice"
                                  checked={checkQ_6_3 === "Voice"}
                                  onChange={() => startQuiz_6_3("Voice")}
                                />
                                {isfirstquiz_6_3 &&
                                  (issetQuizAns_6_3_btn === "Voice" ? (
                                    <div className="check">
                                      <i className="fas fa-check text-success"></i>
                                    </div>
                                  ) : (
                                    <div className="check1">
                                      <i className="fas fa-times text-fail"></i>
                                    </div>
                                  ))}
                              </div>
                              <label className="form-check-label" for="Voice">
                                Voice
                              </label>
                            </div>
                            <div
                              className={`form-check ${isOpacity_6_1 ? " opacityy" : ""
                                }`}
                            >
                              <div class="position-relative">
                                <input
                                  className="form-check-input"
                                  type="radio"
                                  name="q3"
                                  id="Guard_Dogs"
                                  checked={checkQ_6_3 === "Guard_Dogs"}
                                  onChange={() => startQuiz_6_3("Guard_Dogs")}
                                />
                                {isfirstquiz_6_3 &&
                                  (issetQuizAns_6_3_btn === "Guard_Dogs" ? (
                                    <div className="check">
                                      <i className="fas fa-check text-success"></i>
                                    </div>
                                  ) : (
                                    <div className="check1">
                                      <i className="fas fa-times text-fail"></i>
                                    </div>
                                  ))}
                              </div>
                              <label
                                className="form-check-label"
                                for="Guard_Dogs"
                              >
                                Guard Dogs
                              </label>
                            </div>
                            <div
                              className={`form-check ${isOpacity_6_1 ? " opacityy" : ""
                                }`}
                            >
                              <div class="position-relative">
                                <input
                                  className="form-check-input"
                                  type="radio"
                                  name="q3"
                                  id="Fire_Warden"
                                  checked={checkQ_6_3 === "Fire_Warden"}
                                  onChange={() => startQuiz_6_3("Fire_Warden")}
                                />
                                {isfirstquiz_6_3 &&
                                  (issetQuizAns_6_3_btn === "Fire_Warden" ? (
                                    <div className="check">
                                      <i className="fas fa-check text-success"></i>
                                    </div>
                                  ) : (
                                    <div className="check1">
                                      <i className="fas fa-times text-fail"></i>
                                    </div>
                                  ))}
                              </div>
                              <label
                                className="form-check-label"
                                for="Fire_Warden"
                              >
                                Fire Warden
                              </label>
                            </div>
                            {worngansQuiz_6_1 && (
                              <div className="d-flex justify-content-center">
                                <div className="text-center">
                                  <Link to="javascript:void(0)" className="">
                                    <i class="fas fa-times"></i>
                                  </Link>
                                  <p>
                                    <strong>Thanks for confirmation</strong>
                                  </p>
                                  <p>Sorry that's not correct.</p>
                                </div>
                              </div>
                            )}
                            {rightansQuiz_6_1 && (
                              <div className="d-flex justify-content-center">
                                <div className="text-center">
                                  <Link to="javascript:void(0)" className="">
                                    <i class="fas fa-check"></i>
                                  </Link>
                                  <p>
                                    <strong>Thanks for confirmation</strong>
                                  </p>
                                  <p>That's correct - well done.</p>
                                </div>
                              </div>
                            )}
                            {q3_6_next && (
                              <div className="d-flex justify-content-center">
                                <button
                                  type="button"
                                  onClick={() => Quiz_next_6("3")}
                                >
                                  Next
                                </button>
                              </div>
                            )}
                            {checkbtn_quiz_3_6 && (
                              <div className="d-flex justify-content-end">
                                <button
                                  type="button"
                                  onClick={() => Quiz_check_6("3")}
                                >
                                  Submit
                                </button>
                              </div>
                            )}
                          </div>
                        </div>
                      )}
                      {quizless_6_4 && (
                        <div className="d-flex flex-column py-5 fullname-block">
                          <h4>Upon discovering a fire you should...?</h4>

                          <div className="d-flex flex-column mt-4 gap-4 name-form">
                            <h5>Please select the correct answer:</h5>
                            <div
                              className={`form-check ${isOpacity_6_1 ? " opacityy" : ""
                                }`}
                            >
                              <div class="position-relative">
                                <input
                                  className="form-check-input"
                                  type="radio"
                                  name="q4"
                                  id="Tell_a"
                                  checked={checkQ_6_4 === "Tell_a"}
                                  onChange={() => startQuiz_6_4("Tell_a")}
                                />
                                {isfirstquiz_6_4 &&
                                  (issetQuizAns_6_4_btn === "Tell_a" ? (
                                    <div className="check">
                                      <i className="fas fa-check text-success"></i>
                                    </div>
                                  ) : (
                                    <div className="check1">
                                      <i className="fas fa-times text-fail"></i>
                                    </div>
                                  ))}
                              </div>
                              <label className="form-check-label" for="Tell_a">
                                Tell a supervisor
                              </label>
                            </div>
                            <div
                              className={`form-check ${isOpacity_6_1 ? " opacityy" : ""
                                }`}
                            >
                              <div class="position-relative">
                                <input
                                  className="form-check-input"
                                  type="radio"
                                  name="q4"
                                  id="Sound_the"
                                  checked={checkQ_6_4 === "Sound_the"}
                                  onChange={() => startQuiz_6_4("Sound_the")}
                                />
                                {isfirstquiz_6_4 &&
                                  (issetQuizAns_6_4_btn === "Sound_the" ? (
                                    <div className="check">
                                      <i className="fas fa-check text-success"></i>
                                    </div>
                                  ) : (
                                    <div className="check1">
                                      <i className="fas fa-times text-fail"></i>
                                    </div>
                                  ))}
                              </div>
                              <label
                                className="form-check-label"
                                for="Sound_the"
                              >
                                Sound the alarm immediately
                              </label>
                            </div>
                            <div
                              className={`form-check ${isOpacity_6_1 ? " opacityy" : ""
                                }`}
                            >
                              <div class="position-relative">
                                <input
                                  className="form-check-input"
                                  type="radio"
                                  name="q4"
                                  id="Close_the"
                                  checked={checkQ_6_4 === "Close_the"}
                                  onChange={() => startQuiz_6_4("Close_the")}
                                />
                                {isfirstquiz_6_4 &&
                                  (issetQuizAns_6_4_btn === "Close_the" ? (
                                    <div className="check">
                                      <i className="fas fa-check text-success"></i>
                                    </div>
                                  ) : (
                                    <div className="check1">
                                      <i className="fas fa-times text-fail"></i>
                                    </div>
                                  ))}
                              </div>
                              <label
                                className="form-check-label"
                                for="Close_the"
                              >
                                Close the door hope that the fire is contained
                              </label>
                            </div>
                            <div
                              className={`form-check ${isOpacity_6_1 ? " opacityy" : ""
                                }`}
                            >
                              <div class="position-relative">
                                <input
                                  className="form-check-input"
                                  type="radio"
                                  name="q4"
                                  id="Wait_to"
                                  checked={checkQ_6_4 === "Wait_to"}
                                  onChange={() => startQuiz_6_4("Wait_to")}
                                />
                                {isfirstquiz_6_4 &&
                                  (issetQuizAns_6_4_btn === "Wait_to" ? (
                                    <div className="check">
                                      <i className="fas fa-check text-success"></i>
                                    </div>
                                  ) : (
                                    <div className="check1">
                                      <i className="fas fa-times text-fail"></i>
                                    </div>
                                  ))}
                              </div>
                              <label className="form-check-label" for="Wait_to">
                                Wait to see if anyone else sound the alarm
                              </label>
                            </div>
                            {worngansQuiz_6_1 && (
                              <div className="d-flex justify-content-center">
                                <div className="text-center">
                                  <Link to="javascript:void(0)" className="">
                                    <i class="fas fa-times"></i>
                                  </Link>
                                  <p>
                                    <strong>Thanks for confirmation</strong>
                                  </p>
                                  <p>Sorry that's not correct.</p>
                                </div>
                              </div>
                            )}
                            {rightansQuiz_6_1 && (
                              <div className="d-flex justify-content-center">
                                <div className="text-center">
                                  <Link to="javascript:void(0)" className="">
                                    <i class="fas fa-check"></i>
                                  </Link>
                                  <p>
                                    <strong>Thanks for confirmation</strong>
                                  </p>
                                  <p>That's correct - well done.</p>
                                </div>
                              </div>
                            )}
                            {q4_6_next && (
                              <div className="d-flex justify-content-center">
                                <button
                                  type="button"
                                  onClick={() => Quiz_next_6("4")}
                                >
                                  Next
                                </button>
                              </div>
                            )}
                            {checkbtn_quiz_4_6 && (
                              <div className="d-flex justify-content-end">
                                <button
                                  type="button"
                                  onClick={() => Quiz_check_6("4")}
                                >
                                  Submit
                                </button>
                              </div>
                            )}
                          </div>
                        </div>
                      )}
                      {quizless_6_5 && (
                        <div className="d-flex flex-column py-5 fullname-block">
                          <h4>
                            What external hazards should be taken into
                            consideration when preparing an emergency plan?
                          </h4>

                          <div className="d-flex flex-column mt-4 gap-4 name-form">
                            <h5>Please select the correct answer:</h5>
                            <div
                              className={`form-check ${isOpacity_6_1 ? " opacityy" : ""
                                }`}
                            >
                              <div class="position-relative">
                                <input
                                  className="form-check-input"
                                  type="radio"
                                  name="q5"
                                  id="Bush_fires"
                                  checked={checkQ_6_5 === "Bush_fires"}
                                  onChange={() => startQuiz_6_5("Bush_fires")}
                                />
                                {isfirstquiz_6_5 &&
                                  (issetQuizAns_6_5_btn === "Bush_fires" ? (
                                    <div className="check">
                                      <i className="fas fa-check text-success"></i>
                                    </div>
                                  ) : (
                                    <div className="check1">
                                      <i className="fas fa-times text-fail"></i>
                                    </div>
                                  ))}
                              </div>
                              <label
                                className="form-check-label"
                                for="Bush_fires"
                              >
                                Bush fires
                              </label>
                            </div>
                            <div
                              className={`form-check ${isOpacity_6_1 ? " opacityy" : ""
                                }`}
                            >
                              <div class="position-relative">
                                <input
                                  className="form-check-input"
                                  type="radio"
                                  name="q5"
                                  id="Floods"
                                  checked={checkQ_6_5 === "Floods"}
                                  onChange={() => startQuiz_6_5("Floods")}
                                />
                                {isfirstquiz_6_5 &&
                                  (issetQuizAns_6_5_btn === "Floods" ? (
                                    <div className="check">
                                      <i className="fas fa-check text-success"></i>
                                    </div>
                                  ) : (
                                    <div className="check1">
                                      <i className="fas fa-times text-fail"></i>
                                    </div>
                                  ))}
                              </div>
                              <label className="form-check-label" for="Floods">
                                Floods
                              </label>
                            </div>
                            <div
                              className={`form-check ${isOpacity_6_1 ? " opacityy" : ""
                                }`}
                            >
                              <div class="position-relative">
                                <input
                                  className="form-check-input"
                                  type="radio"
                                  name="q5"
                                  id="Public_Health"
                                  checked={checkQ_6_5 === "Public_Health"}
                                  onChange={() =>
                                    startQuiz_6_5("Public_Health")
                                  }
                                />
                                {isfirstquiz_6_5 &&
                                  (issetQuizAns_6_5_btn === "Public_Health" ? (
                                    <div className="check">
                                      <i className="fas fa-check text-success"></i>
                                    </div>
                                  ) : (
                                    <div className="check1">
                                      <i className="fas fa-times text-fail"></i>
                                    </div>
                                  ))}
                              </div>
                              <label
                                className="form-check-label"
                                for="Public_Health"
                              >
                                Public Health orders
                              </label>
                            </div>
                            <div
                              className={`form-check ${isOpacity_6_1 ? " opacityy" : ""
                                }`}
                            >
                              <div class="position-relative">
                                <input
                                  className="form-check-input"
                                  type="radio"
                                  name="q5"
                                  id="Earthquakes"
                                  checked={checkQ_6_5 === "Earthquakes"}
                                  onChange={() => startQuiz_6_5("Earthquakes")}
                                />
                                {isfirstquiz_6_5 &&
                                  (issetQuizAns_6_5_btn === "Earthquakes" ? (
                                    <div className="check">
                                      <i className="fas fa-check text-success"></i>
                                    </div>
                                  ) : (
                                    <div className="check1">
                                      <i className="fas fa-times text-fail"></i>
                                    </div>
                                  ))}
                              </div>
                              <label
                                className="form-check-label"
                                for="Earthquakes"
                              >
                                Earthquakes
                              </label>
                            </div>
                            {worngansQuiz_6_1 && (
                              <div className="d-flex justify-content-center">
                                <div className="text-center">
                                  <Link to="javascript:void(0)" className="">
                                    <i class="fas fa-times"></i>
                                  </Link>
                                  <p>
                                    <strong>Thanks for confirmation</strong>
                                  </p>
                                  <p>Sorry that's not correct.</p>
                                </div>
                              </div>
                            )}
                            {rightansQuiz_6_1 && (
                              <div className="d-flex justify-content-center">
                                <div className="text-center">
                                  <Link to="javascript:void(0)" className="">
                                    <i class="fas fa-check"></i>
                                  </Link>
                                  <p>
                                    <strong>Thanks for confirmation</strong>
                                  </p>
                                  <p>That's correct - well done.</p>
                                </div>
                              </div>
                            )}
                            {q5_6_next && (
                              <div className="d-flex justify-content-center">
                                <button
                                  type="button"
                                  onClick={() => Quiz_next_6("5")}
                                >
                                  Next
                                </button>
                              </div>
                            )}
                            {checkbtn_quiz_5_6 && (
                              <div className="d-flex justify-content-end">
                                <button
                                  type="button"
                                  onClick={() => Quiz_check_6("5")}
                                >
                                  Submit
                                </button>
                              </div>
                            )}
                          </div>
                        </div>
                      )}
                      {less_5_finresult && (
                        <div className="d-flex flex-column gap-3 text-center results-block">
                          <h3 className="text-danger">Results</h3>

                          <div className="row gy-3 gy-md-5">
                            <div className="col-lg-6">
                              <h3>
                                <b>Your Score:</b>
                              </h3>
                            </div>
                            <div className="col-lg-6">
                              <h3>
                                {score__per5}% ({score_5} points)
                              </h3>
                            </div>
                            <div className="col-lg-6">
                              <h3>
                                <b>Passing Score:</b>
                              </h3>
                            </div>
                            <div className="col-lg-6">
                              <h3>80% (40 points)</h3>
                            </div>
                            <div className="col-12">
                              {!corrScore && (
                                <h4 className="text-danger">
                                  <i className="far fa-times"></i> You did not
                                  pass
                                </h4>
                              )}
                              {corrScore && (
                                <h4 className="text-success">
                                  <i className="far fa-check text-fail"></i> You
                                  pass
                                </h4>
                              )}
                            </div>
                            {!corrScore ? (
                              <div className="col-lg-">
                                <button type="button" onClick={refreshbtn}>
                                  Retry Assessment
                                </button>
                              </div>
                            ) : (
                              <div className="col-lg-">
                                <button type="button" onClick={downloadpdf}>
                                  Download
                                </button>
                              </div>
                            )}
                          </div>
                        </div>
                      )}
                    </div>
                  </form>
                </div>
              </div>
            </section>
          )}
        </div>
      </div>
    </>
  );
};
